webpackJsonp([1],Array(33).concat([
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex_persistedstate__ = __webpack_require__(658);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_Users__ = __webpack_require__(501);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_Loader__ = __webpack_require__(485);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modules_Conseillers__ = __webpack_require__(481);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__modules_Cabinets__ = __webpack_require__(471);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__modules_Clients__ = __webpack_require__(476);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__modules_Office__ = __webpack_require__(496);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__modules_Notifications__ = __webpack_require__(491);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__state__ = __webpack_require__(207);














__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* default */]);

var store = new __WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* default */].Store({
	strict: true,
	plugins: [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex_persistedstate__["a" /* default */])({
		key: __WEBPACK_IMPORTED_MODULE_10__state__["a" /* STORAGE_KEY */]
	})],
	modules: {
		users: __WEBPACK_IMPORTED_MODULE_3__modules_Users__["a" /* default */],
		loader: __WEBPACK_IMPORTED_MODULE_4__modules_Loader__["a" /* default */],
		clients: __WEBPACK_IMPORTED_MODULE_7__modules_Clients__["a" /* default */],
		cabinets: __WEBPACK_IMPORTED_MODULE_6__modules_Cabinets__["a" /* default */],
		conseillers: __WEBPACK_IMPORTED_MODULE_5__modules_Conseillers__["a" /* default */],
		office: __WEBPACK_IMPORTED_MODULE_8__modules_Office__["a" /* default */],

		notifications: __WEBPACK_IMPORTED_MODULE_9__modules_Notifications__["a" /* default */]
	}
});

/* harmony default export */ __webpack_exports__["a"] = (store);

/***/ }),
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(596)

var Component = __webpack_require__(12)(
  /* script */
  __webpack_require__(509),
  /* template */
  __webpack_require__(649),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(589)

var Component = __webpack_require__(12)(
  /* script */
  __webpack_require__(508),
  /* template */
  __webpack_require__(642),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__fixtures_notifications__ = __webpack_require__(462);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_apiService__ = __webpack_require__(75);




var User = {
  login: function login(email, password) {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_2__services_apiService__["a" /* default */].post('api/login', {
        username: email,
        password: password
      }).then(function (result) {
        if (!result.data || !result.data.user || !result.data.user.roles) {
          reject(new Error('Result format not supported'));
        }
        var roles = result.data.user.roles;

        if (roles.indexOf('ROLE_ADMIN') === -1 && roles.indexOf('ROLE_SUPER_ADMIN') === -1) {
          reject(new Error('You are not admin.'));
        }
        resolve(result.data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  getUser: function getUser() {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_2__services_apiService__["a" /* default */].get('api/profile').then(function (result) {
        resolve(result.data.user);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  logout: function logout() {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_2__services_apiService__["a" /* default */].get('api/logout').then(function (result) {
        resolve();
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  resetPassword: function resetPassword(email) {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_2__services_apiService__["a" /* default */].post('api/resetting/request', {
        email: email
      }).then(function () {
        resolve(true);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  getNotifications: function getNotifications(id) {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      if (id === 1) {
        window.setTimeout(function () {
          resolve(__WEBPACK_IMPORTED_MODULE_1__fixtures_notifications__["a" /* default */]);
        }, 1000);
      } else {
        window.setTimeout(function () {
          reject();
        }, 1000);
      }
    });
  },
  updateProfile: function updateProfile(data) {
    var request = new FormData();
    request.append('first_name', data.firstname);
    request.append('last_name', data.lastname);
    request.append('email', data.email);

    request.append('address', data.address.line);
    request.append('zipcode', data.address.zip);
    request.append('city', data.address.city);
    request.append('country', data.address.country);
    request.append('phone', data.phone);
    return __WEBPACK_IMPORTED_MODULE_2__services_apiService__["a" /* default */].post('api/profile', request);
  },
  editPassword: function editPassword(data) {
    return __WEBPACK_IMPORTED_MODULE_2__services_apiService__["a" /* default */].post('api/change-password', data);
  },
  enableUser: function enableUser(id) {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_2__services_apiService__["a" /* default */].post('api/enable-user/' + id).then(function (result) {
        resolve(result);
      }).catch(function (error) {
        return reject(error);
      });
    });
  },
  disableUser: function disableUser(id) {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_2__services_apiService__["a" /* default */].post('api/disable-user/' + id).then(function (result) {
        resolve(result);
      }).catch(function (error) {
        return reject(error);
      });
    });
  }
};

/* harmony default export */ __webpack_exports__["a"] = (User);

/***/ }),
/* 75 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store__ = __webpack_require__(33);






var ApiService = function () {
    function ApiService() {
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, ApiService);

        this.root = "https://api-preprod.patrimoffice.com/";
    }

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(ApiService, [{
        key: 'post',
        value: function post(url, data) {
            var _this = this;

            var type = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

            console.log('[POST] // API CALL : ', url);
            return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post(_this.root + url, data, _this.getHeader()).then(function (result) {
                    if (!result.data.success || result.data.success === true) {
                        resolve(result);
                    } else if (result.data.success === false && result.data.error) {
                        reject(result.data.error);
                    } else {
                        reject();
                    }
                }).catch(function (error) {
                    console.error(error);
                    if (error.response.status === 401 && (error.response.data.message === 'Token expiré, reconnectez-vous pour en obtenir un nouveau !' || error.response.data.message === 'Token invalide, reconnectez-vous pour en obtenir un nouveau !')) {
                        _this.refreshToken().then(function () {
                            _this.post(url, data).then(function (result) {
                                resolve(result);
                            }).catch(function (error) {
                                reject(error);
                            });
                        });
                    } else if (error.response.status === 403) {
                        __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].commit('LOGOUT');
                    } else {
                        reject(error);
                    }
                });
            });
        }
    }, {
        key: 'get',
        value: function get(url) {
            var _this2 = this;

            console.log('[GET] // API CALL : ', url);
            return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(_this2.root + url, _this2.getHeader()).then(function (result) {
                    if (!result.data.success || result.data.success === true) {
                        resolve(result);
                    } else if (result.data.success === false && result.data.error) {
                        reject(result.data.error);
                    } else {
                        reject();
                    }
                }).catch(function (error) {
                    if (error.response.status === 401) {
                        _this2.refreshToken().then(function () {
                            _this2.get(url).then(function (result) {
                                resolve(result);
                            }).catch(function (error) {
                                reject(error);
                            });
                        });
                    } else if (error.response.status === 403) {
                        __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].commit('LOGOUT');
                    } else {
                        reject(error);
                    }
                });
            });
        }
    }, {
        key: 'refreshToken',
        value: function refreshToken() {
            var _this3 = this;

            var refresh = __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].state.users.refresh;
            return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                console.log('REFRESH TOKEN', refresh);
                __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post(_this3.root + 'api/token/refresh', {
                    refresh_token: refresh
                }).then(function (result) {
                    console.log('TOKEN REFRESH SUCCESS');
                    __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].commit('SET_TOKENS', result.data);
                    resolve();
                }).catch(function (error) {
                    reject(error);
                    __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].commit('LOGOUT');
                    window.location = '/login';
                });
            });
        }
    }, {
        key: 'getHeader',
        value: function getHeader() {
            var token = __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].state.users.token;
            if (token !== null) {
                return {
                    headers: {
                        'X-Auth-Token': 'Bearer ' + token
                    }
                };
            } else {
                return null;
            }
        }
    }]);

    return ApiService;
}();

var apiService = new ApiService();

/* harmony default export */ __webpack_exports__["a"] = (apiService);

/***/ }),
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(590)

var Component = __webpack_require__(12)(
  /* script */
  __webpack_require__(506),
  /* template */
  __webpack_require__(643),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store_state__ = __webpack_require__(207);







var Emma = function () {
	function Emma() {
		__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Emma);

		var user = null;
		if (JSON.parse(window.localStorage.getItem(__WEBPACK_IMPORTED_MODULE_5__store_state__["a" /* STORAGE_KEY */]))) {
			user = JSON.parse(window.localStorage.getItem(__WEBPACK_IMPORTED_MODULE_5__store_state__["a" /* STORAGE_KEY */])).users;
			if (user) {
				this.refresh = user.refresh || null;
				this.token = user.token || null;
				console.log(user);
			}
		}
		this.root = "https://api-preprod.patrimoffice.com/";
	}

	__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Emma, [{
		key: 'post',
		value: function post(url, data) {
			var _this = this;

			var type = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

			var requestHeader = null;

			if (url !== 'api/login' && url.indexOf('api/resetting') === -1) {
				console.log('test1 -------------------------');
				console.log(this.token);
				requestHeader = this.getHeader();
				console.log('test2 -------------------------');
			}

			if (type) {
				requestHeader.headers['Content-Type'] = type;
			}

			if (__webpack_require__.i({"NODE_ENV":"development","API_ROOT":"https://api-preprod.patrimoffice.com/","BASE":"https://backoffice-preprod.patrimoffice.com","ASSETS_ROOT":"https://api-preprod.patrimoffice.com/api/pictures/","USER_TOKEN_DURATION":"1200"}).SITE === 'client' && (url === 'api/login' || url === 'api/register')) {
				requestHeader = { headers: { HTTP_REFERER: "https://backoffice-preprod.patrimoffice.com" } };
			}

			console.log('[POST] // API CALL : ', url);
			return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
				__WEBPACK_IMPORTED_MODULE_3_axios___default.a.post(_this.root + url, data, requestHeader).then(function (result) {
					resolve(result);
				}).catch(function (error) {
					if (error.response.data.code === 403) {
						_this.refreshToken().then(function () {
							_this.post(url, data, type).then(function (result) {
								resolve(result);
							}).catch(function (error) {
								reject(error);
							});
						});
					} else {
						reject(error);
					}
				});
			});
		}
	}, {
		key: 'get',
		value: function get(url) {
			var _this2 = this;

			console.log('[GET] // API CALL : ', url);
			return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
				__WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(_this2.root + url, _this2.getHeader()).then(function (result) {
					resolve(result);
				}).catch(function (error) {
					if (error.response.data.code === 403) {
						_this2.refreshToken(url !== 'api/logout').then(function () {
							_this2.get(url).then(function (result) {
								resolve(result);
							}).catch(function (error) {
								reject(error);
							});
						});
					} else {
						reject(error);
					}
				});
			});
		}
	}, {
		key: 'refreshToken',
		value: function refreshToken() {
			var _this3 = this;

			return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
				console.log('REFRESH TOKEN', _this3.refresh);
				if (_this3.refresh) {
					__WEBPACK_IMPORTED_MODULE_3_axios___default.a.post(_this3.root + 'api/token/refresh', {
						refresh_token: _this3.refresh
					}).then(function (result) {
						console.log('TOKEN REFRESH SUCCESS');
						_this3.refresh = result.data.refresh_token;
						_this3.token = result.data.token;
						__WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].commit('SET_TOKENS', { user: result.data });
						resolve();
					}).catch(function (error) {
						reject(error);
						__WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].commit('LOGOUT');
						window.location = '/login';
					});
				}
			});
		}
	}, {
		key: 'setToken',
		value: function setToken(refreshToken, token) {
			this.refresh = refreshToken;
			this.token = token;
		}
	}, {
		key: 'getHeader',
		value: function getHeader() {
			if (this.token) {
				return {
					headers: {
						'X-Auth-Token': 'Bearer ' + this.token
					}
				};
			} else {
				return null;
			}
		}
	}]);

	return Emma;
}();

var emma = new Emma();

/* harmony default export */ __webpack_exports__["a"] = (emma);

/***/ }),
/* 201 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var countries = ['France', 'Royaume-Uni', 'Allemagne', 'Italie', 'Suisse', 'Espagne'];

/* harmony default export */ __webpack_exports__["a"] = (countries);

/***/ }),
/* 202 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SET_CABINETS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CREATE_CABINET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return EDIT_CABINET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SET_CLIENTS_BY_OFFICEID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return SET_ADVISORS_BY_OFFICEID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return SET_ADMIN_BY_OFFICEID; });
var SET_CABINETS = 'SET_CABINETS';
var CREATE_CABINET = 'CREATE_CABINET';
var EDIT_CABINET = 'EDIT_CABINET';
var SET_CLIENTS_BY_OFFICEID = 'SET_CLIENTS_BY_OFFICEID';
var SET_ADVISORS_BY_OFFICEID = 'SET_ADVISORS_BY_OFFICEID';
var SET_ADMIN_BY_OFFICEID = 'SET_ADMIN_BY_OFFICEID';

/***/ }),
/* 203 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SET_CLIENTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SET_CLIENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return SET_ESTATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return CREATE_CLIENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return EDIT_CLIENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return ENABLE_CLIENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return DISABLE_CLIENT; });
var SET_CLIENTS = 'SET_CLIENTS';
var SET_CLIENT = 'SET_CLIENT';
var SET_ESTATE = 'SET_ESTATE';
var CREATE_CLIENT = 'CREATE_CLIENT';
var EDIT_CLIENT = 'EDIT_CLIENT';
var ENABLE_CLIENT = 'ENABLE_CLIENT';
var DISABLE_CLIENT = 'DISABLE_CLIENT';

/***/ }),
/* 204 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GET_ADVISORS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CREATE_ADVISOR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return EDIT_ADVISOR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return ENABLE_ADVISOR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return DISABLE_ADVISOR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return ENABLE_ADVISOR_CLIENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return DISABLE_ADVISOR_CLIENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return SET_ADVISOR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return SET_CLIENTS; });
var GET_ADVISORS = 'GET_ADVISORS';
var CREATE_ADVISOR = 'CREATE_ADVISOR';
var EDIT_ADVISOR = 'EDIT_ADVISOR';
var ENABLE_ADVISOR = 'ENABLE_ADVISOR';
var DISABLE_ADVISOR = 'DISABLE_ADVISOR';
var ENABLE_ADVISOR_CLIENT = 'ENABLE_ADVISOR_CLIENT';
var DISABLE_ADVISOR_CLIENT = 'DISABLE_ADVISOR_CLIENT';
var SET_ADVISOR = 'SET_ADVISOR';
var SET_CLIENTS = 'SET_CLIENTS';

/***/ }),
/* 205 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export READ */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FETCH_NOTIFICATIONS; });

var READ = 'READ';
var FETCH_NOTIFICATIONS = 'FETCH_NOTIFICATIONS';

/***/ }),
/* 206 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return LOGIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return LOGOUT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return UPDATE_PROFILE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return GET_ADVISORS; });
/* unused harmony export CHANGE_PASSWORD */
/* unused harmony export GET_CLIENTS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SET_TOKENS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SET_USER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return PROFIL_PICTURE; });

var LOGIN = 'LOGIN';
var LOGOUT = 'LOGOUT';
var UPDATE_PROFILE = 'UPDATE_PROFILE';
var GET_ADVISORS = 'GET_ADVISORS';
var CHANGE_PASSWORD = 'CHANGE_PASSWORD';
var GET_CLIENTS = 'GET_CLIENTS';
var SET_TOKENS = 'SET_TOKENS';
var SET_USER = 'SET_USER';

var PROFIL_PICTURE = 'PROFIL_PICTURE';

/***/ }),
/* 207 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return STORAGE_KEY; });
var STORAGE_KEY = 'patrimoffice-client';

/***/ }),
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/logo-patrim.d52ef96.svg";

/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(595)

var Component = __webpack_require__(12)(
  /* script */
  __webpack_require__(522),
  /* template */
  __webpack_require__(648),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(579)

var Component = __webpack_require__(12)(
  /* script */
  __webpack_require__(527),
  /* template */
  __webpack_require__(630),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 358 */,
/* 359 */,
/* 360 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var Vue = void 0;

function extend(Vue) {
	Vue.directive('inputUI', {
		inserted: function inserted(el) {
			if (el.querySelector('input').value.trim() !== '') el.querySelector('label').classList.add('active');

			el.querySelector('input').addEventListener('focus', function () {
				el.querySelector('label').classList.add('active');
			});

			el.querySelector('input').addEventListener('blur', function () {
				if (el.querySelector('input').value.trim() === '') {
					el.querySelector('label').classList.remove('active');
				}
			});
		}
	});
}

function _install(_Vue) {
	Vue = _Vue;
	extend(Vue);
}

var inputUI = function inputUI() {
	var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
};

inputUI.install = _install;
inputUI.version = '0.0.1';

/* harmony default export */ __webpack_exports__["a"] = (inputUI);

/***/ }),
/* 361 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var Vue = void 0;

function extend(Vue) {
	Vue.directive('selectUI', function (el, binding) {
		if (el.querySelector('.custom-select .selected').innerHTML.replace('<span class="icon-arrow-full-down"></span>', '').trim() !== '&nbsp;') {
			el.querySelector('label').classList.add('active');
		}

		el.querySelector('.custom-select .selected').addEventListener('click', function () {
			el.querySelector('label').classList.add('active');
		});
	});
}

function _install(_Vue) {
	Vue = _Vue;
	extend(Vue);
}

var selectUI = function selectUI() {
	var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
};

selectUI.install = _install;
selectUI.version = '0.0.1';

/* harmony default export */ __webpack_exports__["a"] = (selectUI);

/***/ }),
/* 362 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__);

var Vue = void 0;

function extend(Vue) {
	Vue.directive('domino', function (el, binding) {
		var content = binding.value.content;
		var elem = [];
		el.innerHTML = '';
		el.classList.add('domino-effect');
		__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default()(content).forEach(function (c, i) {
			var s = document.createElement('span');
			s.classList.add('domino-char');
			s.setAttribute('rel', i);
			s.innerHTML = c !== ' ' ? c : '&nbsp;';
			el.appendChild(s);
			elem.push(s);
		});

		if (binding.value.active) {
			window.setTimeout(function () {
				trigger(elem, 0);
			}, 100);
		}
	});
}

function trigger(elem, i) {
	elem[i].classList.add('active');
	if (i < elem.length - 1) {
		window.setTimeout(function () {
			trigger(elem, i + 1);
		}, 100);
	}
}

function _install(_Vue) {
	Vue = _Vue;
	extend(Vue);
}

var Domino = function Domino() {
	var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
};

Domino.install = _install;
Domino.version = '0.0.1';
/* harmony default export */ __webpack_exports__["a"] = (Domino);

/***/ }),
/* 363 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(656);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_Login__ = __webpack_require__(625);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_Login___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__views_Login__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_Main__ = __webpack_require__(626);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_Main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__views_Main__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_Profile__ = __webpack_require__(627);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_Profile___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__views_Profile__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__views_Conseillers_index__ = __webpack_require__(624);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__views_Conseillers_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__views_Conseillers_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__views_Conseillers_details_Details__ = __webpack_require__(623);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__views_Conseillers_details_Details___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__views_Conseillers_details_Details__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__views_Clients_index__ = __webpack_require__(620);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__views_Clients_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__views_Clients_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__views_Clients_details_Details__ = __webpack_require__(619);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__views_Clients_details_Details___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__views_Clients_details_Details__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__views_Cabinets_index__ = __webpack_require__(616);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__views_Cabinets_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__views_Cabinets_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__views_ResetPassword__ = __webpack_require__(628);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__views_ResetPassword___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__views_ResetPassword__);
















__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var myRouter = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
	mode: 'history',
	routes: [{
		path: '/',
		component: __WEBPACK_IMPORTED_MODULE_4__views_Main___default.a,
		children: [{
			path: '',
			name: 'Main',
			redirect: { name: 'Profile' }
		}, {
			path: 'profile',
			component: __WEBPACK_IMPORTED_MODULE_5__views_Profile___default.a,
			name: 'Profile'
		}, {
			path: 'conseillers/:id',
			component: __WEBPACK_IMPORTED_MODULE_7__views_Conseillers_details_Details___default.a,
			name: 'ConseillersDetails'
		}, {
			path: 'conseillers',
			component: __WEBPACK_IMPORTED_MODULE_6__views_Conseillers_index___default.a,
			name: 'Conseillers'
		}, {
			path: 'clients/:id',
			component: __WEBPACK_IMPORTED_MODULE_9__views_Clients_details_Details___default.a,
			name: 'ClientsDetails'
		}, {
			path: 'clients',
			component: __WEBPACK_IMPORTED_MODULE_8__views_Clients_index___default.a,
			name: 'Clients'
		}, {
			path: 'cabinets',
			component: __WEBPACK_IMPORTED_MODULE_10__views_Cabinets_index___default.a,
			name: 'Cabinets'
		}, {
			path: 'statistiques',
			component: null,
			name: 'Statistiques'
		}, {
			path: 'encaissements',
			component: null,
			name: 'Encaissements'
		}, {
			path: 'supports/:id',
			component: null,
			name: 'SupportDetails'
		}, {
			path: 'contracts',
			component: null,
			name: 'ContractsSupports'
		}]
	}, {
		path: '/login',
		component: __WEBPACK_IMPORTED_MODULE_3__views_Login___default.a,
		name: 'Login',
		meta: {
			requiresAuth: false
		}
	}, {
		path: '/reset-password',
		component: __WEBPACK_IMPORTED_MODULE_3__views_Login___default.a,
		name: 'ResetPasswordEmailAsk',
		meta: {
			requiresAuth: false
		}
	}, {
		path: '/reset-password/:token',
		component: __WEBPACK_IMPORTED_MODULE_11__views_ResetPassword___default.a,
		name: 'ResetPassword',
		meta: {
			requiresAuth: false
		}
	}, {
		path: '*',
		redirect: { name: 'Main' }
	}]
});

myRouter.beforeEach(function (to, from, next) {
	if (__WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters.isAuthenticated && __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters.isTokenExpired) {
		__WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].commit('LOGOUT');
		next({ name: 'Login' });
	} else {
		if (typeof to.meta.requiresAuth !== 'undefined' && to.meta.requiresAuth === false && __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters.isAuthenticated) {
			next({ name: 'Main' });
		} else if ((typeof to.meta.requiresAuth === 'undefined' || to.meta.requiresAuth === true) && !__WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters.isAuthenticated) {
			next({ name: 'Login' });
		} else {
			next();
		}
	}
});

/* harmony default export */ __webpack_exports__["a"] = (myRouter);

/***/ }),
/* 364 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 365 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 366 */,
/* 367 */,
/* 368 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(598)

var Component = __webpack_require__(12)(
  /* script */
  __webpack_require__(505),
  /* template */
  __webpack_require__(651),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(588)

var Component = __webpack_require__(12)(
  /* script */
  __webpack_require__(511),
  /* template */
  __webpack_require__(641),
  /* scopeId */
  "data-v-536eb19e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(12)(
  /* script */
  __webpack_require__(512),
  /* template */
  __webpack_require__(636),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_services_Emma__ = __webpack_require__(200);


var OfficeResource = {
	createOffice: function createOffice(data) {
		return __WEBPACK_IMPORTED_MODULE_0__common_services_Emma__["a" /* default */].post('api/office', data);
	},
	updateOfficeTheme: function updateOfficeTheme(id, data) {
		return __WEBPACK_IMPORTED_MODULE_0__common_services_Emma__["a" /* default */].post('api/office/' + id + '/theme', data);
	},
	updateOfficeHosts: function updateOfficeHosts(id, data) {
		return __WEBPACK_IMPORTED_MODULE_0__common_services_Emma__["a" /* default */].post('api/office/' + id + '/hosts', data);
	},
	updateOffice: function updateOffice(id, data) {
		return __WEBPACK_IMPORTED_MODULE_0__common_services_Emma__["a" /* default */].post('api/office/' + id, data);
	},
	updateOfficeLogo: function updateOfficeLogo(id, data) {
		return __WEBPACK_IMPORTED_MODULE_0__common_services_Emma__["a" /* default */].post('api/office/' + id + '/logo', data);
	}
};

/* harmony default export */ __webpack_exports__["a"] = (OfficeResource);

/***/ }),
/* 461 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var cabinets = [{
    id: 1,
    cabinetId: '079642-7610',
    name: {
        text: 'Betatech',
        color: '#f0483a'
    },
    admin: 'Danny Osborne',
    contractStart: '2018-08-13T11:22:55.416Z',
    contractEnd: '2019-08-13T11:22:55.416Z',
    updatedAt: '2018-08-17T11:22:55.416Z',
    advisors: ['conseiller1', 'conseiller2', 'conseiller3'],
    clients: ['client1', 'client2', 'client3', 'client4'],
    available: true
}, {
    id: 2,
    cabinetId: '859400-7610',
    name: {
        text: 'Cancity',
        color: '#feb93d'
    },
    admin: 'Angel Cooper',
    contractStart: '2018-08-13T11:22:55.416Z',
    contractEnd: '2019-08-13T11:22:55.416Z',
    updatedAt: '2018-08-17T11:22:55.416Z',
    advisors: ['conseiller1', 'conseiller2', 'conseiller3', 'conseiller2', 'conseiller3'],
    clients: ['client1', 'client2', 'client3', 'client4'],
    available: false
}, {
    id: 3,
    cabinetId: '598498-7610',
    name: {
        text: 'Kontmatfix',
        color: '#a0ac47'
    },
    admin: 'Tayler Haynes',
    contractStart: '2018-08-13T11:22:55.416Z',
    contractEnd: '2019-08-13T11:22:55.416Z',
    updatedAt: '2018-08-17T11:22:55.416Z',
    advisors: ['conseiller1', 'conseiller2'],
    clients: ['client1', 'client2'],
    available: true
}, {
    id: 4,
    cabinetId: '059393-7610',
    name: {
        text: 'Aquilogia',
        color: '#ffda00'
    },
    admin: 'Jason Aguilar',
    contractStart: '2018-08-13T11:22:55.416Z',
    contractEnd: '2019-08-13T11:22:55.416Z',
    updatedAt: '2018-08-17T11:22:55.416Z',
    advisors: ['conseiller1'],
    clients: ['client1', 'client2', 'client3'],
    available: false
}, {
    id: 5,
    cabinetId: '958433-7610',
    name: {
        text: 'Iselectrics',
        color: '#0ecc48'
    },
    admin: 'Harry Mathis',
    contractStart: '2018-08-13T11:22:55.416Z',
    contractEnd: '2019-08-13T11:22:55.416Z',
    updatedAt: '2018-08-17T11:22:55.416Z',
    advisors: ['conseiller1', 'conseiller2', 'conseiller3'],
    clients: ['client1', 'client2', 'client3', 'client4'],
    available: true
}];

/* harmony default export */ __webpack_exports__["a"] = (cabinets);

/***/ }),
/* 462 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var NotifData = [{
	key: 0,
	date: new Date('2018', '6', '24', '16', '0'),
	type: 'article',
	text: 'Understanding Operating Systems',
	read: false,
	elementId: 1
}];

/* harmony default export */ __webpack_exports__["a"] = (NotifData);

/***/ }),
/* 463 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var conseillers = [{
    id: 1,
    name: "Jean-François",
    picture: 'https://scontent-frt3-2.xx.fbcdn.net/v/t31.0-8/28423768_10213611233147237_3439682089754223558_o.jpg?_nc_cat=0&oh=63f456cc3b88b822b827ba685c1a0efe&oe=5BDBDF34',
    cabinetId: 56,
    company: "cabinet1",
    email: 'jf@test.fr',
    phone: '412-456-2318',
    address: '28 rue des fromagers',
    city: 'Paris',
    country: 'France',
    advisor: 'JP le conseiller',
    role: 'client',
    available: true
}, {
    id: 2,
    name: "Jean-François2",
    picture: 'https://scontent-frt3-2.xx.fbcdn.net/v/t31.0-8/28423768_10213611233147237_3439682089754223558_o.jpg?_nc_cat=0&oh=63f456cc3b88b822b827ba685c1a0efe&oe=5BDBDF34',
    cabinetId: 56,
    company: "cabinet3",
    email: 'jf@test.fr',
    phone: '412-456-2318',
    address: '28 rue des fromagers',
    city: 'Paris',
    country: 'France',
    role: 'Admin',
    available: true
}, {
    id: 3,
    name: "Jean-François3",
    picture: 'https://scontent-frt3-2.xx.fbcdn.net/v/t31.0-8/28423768_10213611233147237_3439682089754223558_o.jpg?_nc_cat=0&oh=63f456cc3b88b822b827ba685c1a0efe&oe=5BDBDF34',
    cabinetId: 56,
    company: "cabinet1",
    email: 'jf@test.fr',
    phone: '412-456-2318',
    address: '28 rue des fromagers',
    city: 'Paris',
    country: 'France',
    role: 'CGP',
    available: false
}, {
    id: 4,
    name: "Jean-François4",
    picture: 'https://scontent-frt3-2.xx.fbcdn.net/v/t31.0-8/28423768_10213611233147237_3439682089754223558_o.jpg?_nc_cat=0&oh=63f456cc3b88b822b827ba685c1a0efe&oe=5BDBDF34',
    cabinetId: 56,
    company: "cabinet3",
    email: 'jf@test.fr',
    phone: '412-456-2318',
    address: '28 rue des fromagers',
    city: 'Paris',
    country: 'France',
    advisor: 'Robert le conseiller',
    role: 'client',
    available: true
}, {
    id: 5,
    name: "Jean-François5",
    picture: 'https://scontent-frt3-2.xx.fbcdn.net/v/t31.0-8/28423768_10213611233147237_3439682089754223558_o.jpg?_nc_cat=0&oh=63f456cc3b88b822b827ba685c1a0efe&oe=5BDBDF34',
    cabinetId: 56,
    company: "cabinet2",
    email: 'jf@test.fr',
    phone: '412-456-2318',
    address: '28 rue des fromagers',
    city: 'Paris',
    country: 'France',
    role: 'CGP',
    available: false
}, {
    id: 6,
    name: "Jean-François6",
    picture: 'https://scontent-frt3-2.xx.fbcdn.net/v/t31.0-8/28423768_10213611233147237_3439682089754223558_o.jpg?_nc_cat=0&oh=63f456cc3b88b822b827ba685c1a0efe&oe=5BDBDF34',
    cabinetId: 56,
    company: "cabinet2",
    email: 'jf@test.fr',
    phone: '412-456-2318',
    address: '28 rue des fromagers',
    city: 'Paris',
    country: 'France',
    role: 'Admin',
    available: true
}];

/* harmony default export */ __webpack_exports__["a"] = (conseillers);

/***/ }),
/* 464 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_notification__ = __webpack_require__(373);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_notification___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_notification__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vee_validate__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vee_validate_dist_locale_fr__ = __webpack_require__(366);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vee_validate_dist_locale_fr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vee_validate_dist_locale_fr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_moment__ = __webpack_require__(371);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__App__ = __webpack_require__(368);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__router__ = __webpack_require__(363);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__store__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__directives_domino__ = __webpack_require__(362);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__common_directives_inputUI__ = __webpack_require__(360);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__common_directives_selectUI__ = __webpack_require__(361);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__common_components_baseModal__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__common_components_baseModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__common_components_baseModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__common_components_ag_table__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__common_components_ag_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__common_components_ag_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__common_components_toggle_input__ = __webpack_require__(370);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__common_components_toggle_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__common_components_toggle_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vue_multiselect__ = __webpack_require__(372);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_vue_multiselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_vue_select__ = __webpack_require__(374);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_vue_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_vue_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__common_components_Form_CustomSelect__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__common_components_Form_CustomSelect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__common_components_Form_CustomSelect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__common_components_loader__ = __webpack_require__(369);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__common_components_loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__common_components_loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_vue_click_outside__ = __webpack_require__(367);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_vue_click_outside___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_vue_click_outside__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__node_modules_ag_grid_dist_styles_ag_grid_css__ = __webpack_require__(364);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__node_modules_ag_grid_dist_styles_ag_grid_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__node_modules_ag_grid_dist_styles_ag_grid_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__node_modules_ag_grid_dist_styles_ag_theme_balham_css__ = __webpack_require__(365);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__node_modules_ag_grid_dist_styles_ag_theme_balham_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__node_modules_ag_grid_dist_styles_ag_theme_balham_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__sentry_browser__ = __webpack_require__(358);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__sentry_integrations__ = __webpack_require__(359);





















__webpack_require__(102);







__WEBPACK_IMPORTED_MODULE_22__sentry_browser__["a" /* init */]({
	dsn: 'https://34307821ed5b45ee831db2713ca8d484@sentry.io/1846640',
	environment: "development",
	integrations: [new __WEBPACK_IMPORTED_MODULE_23__sentry_integrations__["a" /* Vue */]({ Vue: __WEBPACK_IMPORTED_MODULE_0_vue__["default"], attachProps: true })]
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_9__directives_domino__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_10__common_directives_inputUI__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_11__common_directives_selectUI__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_notification___default.a);
__WEBPACK_IMPORTED_MODULE_2_vee_validate__["a" /* Validator */].localize('fr', __WEBPACK_IMPORTED_MODULE_3_vee_validate_dist_locale_fr___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vee_validate__["b" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_vue_moment___default.a, { moment: __WEBPACK_IMPORTED_MODULE_5_moment___default.a });
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('v-select', __WEBPACK_IMPORTED_MODULE_16_vue_select___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('base-modal', __WEBPACK_IMPORTED_MODULE_12__common_components_baseModal___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('ag-table', __WEBPACK_IMPORTED_MODULE_13__common_components_ag_table___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('multiselect', __WEBPACK_IMPORTED_MODULE_15_vue_multiselect___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('toggle-input', __WEBPACK_IMPORTED_MODULE_14__common_components_toggle_input___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('loader', __WEBPACK_IMPORTED_MODULE_18__common_components_loader___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('custom-select', __WEBPACK_IMPORTED_MODULE_17__common_components_Form_CustomSelect___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].directive('click-outside', __WEBPACK_IMPORTED_MODULE_19_vue_click_outside___default.a);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;

new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
	el: '#app',
	template: '<App/>',
	components: {
		App: __WEBPACK_IMPORTED_MODULE_6__App___default.a
	},
	created: function created() {
		window.Vue = this;
	},
	store: __WEBPACK_IMPORTED_MODULE_8__store__["a" /* default */],
	router: __WEBPACK_IMPORTED_MODULE_7__router__["a" /* default */]
});

/***/ }),
/* 465 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__fixtures_cabinets__ = __webpack_require__(461);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_apiService__ = __webpack_require__(75);





var Cabinets = {
    getCabinets: function getCabinets() {
        return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
            __WEBPACK_IMPORTED_MODULE_3__services_apiService__["a" /* default */].get('api/office').then(function (result) {
                if (result.data && result.data.offices) {
                    resolve(result.data.offices);
                } else {
                    reject();
                }
            }).catch(function (error) {
                return reject(error);
            });
        });
    },
    getClientsByOfficeId: function getClientsByOfficeId(officeId) {
        return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
            __WEBPACK_IMPORTED_MODULE_3__services_apiService__["a" /* default */].get('api/office-clients/' + officeId).then(function (result) {
                if (result.data && result.data.clients) {
                    resolve(result.data.clients);
                } else {
                    reject();
                }
            }).catch(function (error) {
                return reject(error);
            });
        });
    },
    getAdvisorsByOfficeId: function getAdvisorsByOfficeId(officeId) {
        return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
            __WEBPACK_IMPORTED_MODULE_3__services_apiService__["a" /* default */].get('api/office-advisors/' + officeId).then(function (result) {
                if (result.data && result.data.advisors) {
                    resolve(result.data.advisors);
                } else {
                    reject();
                }
            }).catch(function (error) {
                return reject(error);
            });
        });
    },
    getAdminByOfficeId: function getAdminByOfficeId(officeId) {
        return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
            __WEBPACK_IMPORTED_MODULE_3__services_apiService__["a" /* default */].get('api/office-admin/' + officeId).then(function (result) {
                if (result.data && result.data.admin) {
                    resolve(result.data.admin);
                } else {
                    reject();
                }
            }).catch(function (error) {
                return reject(error);
            });
        });
    },
    getCabinetById: function getCabinetById(cabinetId) {
        return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
            window.setTimeout(function () {
                var foundCabinet = __WEBPACK_IMPORTED_MODULE_2__fixtures_cabinets__["a" /* default */].find(function (cabinet) {
                    return cabinet.id === cabinetId;
                });
                if (foundCabinet) {
                    resolve(foundCabinet);
                } else {
                    reject();
                }
            }, 1000);
        });
    },
    editCabinet: function editCabinet(cabinet) {
        return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
            window.setTimeout(function () {
                __WEBPACK_IMPORTED_MODULE_2__fixtures_cabinets__["a" /* default */].forEach(function (el, index) {
                    if (cabinet.id === el.id) {
                        __WEBPACK_IMPORTED_MODULE_2__fixtures_cabinets__["a" /* default */][index] = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, cabinet);
                    }
                });
                resolve(cabinet);
            }, 1000);
        });
    },
    addCabinet: function addCabinet(cabinet) {
        return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
            console.log({ cabinet: cabinet });
            __WEBPACK_IMPORTED_MODULE_3__services_apiService__["a" /* default */].post('api/office/add', cabinet).then(function (result) {
                console.log({ result: result });
                if (result.data && result.data.office) {
                    console.log('POST Office info: ', result.data);
                    resolve(result.data);
                } else {
                    reject();
                }
            }).catch(function (error) {
                return reject(error);
            });
        });
    }
};

/* harmony default export */ __webpack_exports__["a"] = (Cabinets);

/***/ }),
/* 466 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_apiService__ = __webpack_require__(75);



var Clients = {
  getClients: function getClients() {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_1__services_apiService__["a" /* default */].get('api/clients').then(function (result) {
        console.log(result);
        if (result.data && result.data.clients) {
          resolve(result.data.clients);
        } else {
          reject();
        }
      }).catch(function (error) {
        return reject(error);
      });
    });
  },
  getClientById: function getClientById(clientId) {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_1__services_apiService__["a" /* default */].get('api/clients/' + clientId).then(function (result) {
        if (result.data) {
          resolve(result.data.client);
        } else {
          reject();
        }
      }).catch(function (error) {
        return reject(error);
      });
    });
  },
  editClient: function editClient(client) {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_1__services_apiService__["a" /* default */].post('api/update-client', client).then(function (result) {
        if (result.data.success) {
          resolve(result.data.user);
        } else {
          reject(new Error(result.data.message));
        }
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  addClient: function addClient(client) {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_1__services_apiService__["a" /* default */].post('api/clients', client).then(function (result) {
        if (result.data && result.data.user) {
          resolve(result.data.user);
        } else {
          reject();
        }
      }).catch(function (error) {
        return reject(error);
      });
    });
  },
  getClientEstateById: function getClientEstateById(clientId) {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_1__services_apiService__["a" /* default */].get('api/estate/private/' + clientId).then(function (result) {
        if (result.data) {
          resolve(result.data);
        } else {
          reject();
        }
      }).catch(function (error) {
        return reject(error);
      });
    });
  }
};

/* harmony default export */ __webpack_exports__["a"] = (Clients);

/***/ }),
/* 467 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__fixtures_users__ = __webpack_require__(463);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_apiService__ = __webpack_require__(75);





var Conseillers = {
  getConseillers: function getConseillers() {
    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_3__services_apiService__["a" /* default */].get('api/advisors').then(function (result) {
        if (result.data && result.data.advisors) {
          resolve(result.data.advisors);
        } else {
          reject();
        }
      }).catch(function (error) {
        return reject(error);
      });
    });
  },
  getConseillerById: function getConseillerById(conseillerId) {
    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_3__services_apiService__["a" /* default */].get('api/advisor-details/' + conseillerId).then(function (result) {
        if (result.data) {
          resolve(result.data);
        } else {
          reject();
        }
      }).catch(function (error) {
        return reject(error);
      });
    });
  },
  editConseiller: function editConseiller(conseiller) {
    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      window.setTimeout(function () {
        __WEBPACK_IMPORTED_MODULE_2__fixtures_users__["a" /* default */].forEach(function (user, index) {
          if (conseiller.id === user.id) {
            __WEBPACK_IMPORTED_MODULE_2__fixtures_users__["a" /* default */][index] = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, conseiller);
          }
        });
        resolve(conseiller);
      }, 500);
    });
  },
  addConseiller: function addConseiller(conseiller) {
    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_3__services_apiService__["a" /* default */].post('api/advisors', conseiller).then(function (result) {
        if (result.data && result.data.user) {
          resolve(result.data.user);
        } else {
          reject();
        }
      }).catch(function (error) {
        return reject(error);
      });
    });
  }
};

/* harmony default export */ __webpack_exports__["a"] = (Conseillers);

/***/ }),
/* 468 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_apiService__ = __webpack_require__(75);


var Media = {
  getUserImage: function getUserImage(fileName) {
    return __WEBPACK_IMPORTED_MODULE_0__services_apiService__["a" /* default */].root + '/api/pictures/' + fileName;
  },
  updateProfilePicture: function updateProfilePicture(data, id) {
    var request = new FormData();
    request.append('img', data);
    return __WEBPACK_IMPORTED_MODULE_0__services_apiService__["a" /* default */].post('api/media/user_picture/' + id, request, 'application/x-www-form-urlencoded');
  }
};

/* harmony default export */ __webpack_exports__["a"] = (Media);

/***/ }),
/* 469 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return actions; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_api_cabinets__ = __webpack_require__(465);




var actions = {
	getCabinets: function getCabinets(_ref) {
		var commit = _ref.commit;

		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_2__services_api_cabinets__["a" /* default */].getCabinets().then(function (cabinets) {
				commit(__WEBPACK_IMPORTED_MODULE_1__types__["a" /* SET_CABINETS */], cabinets);
				resolve();
			}).catch(function (err) {
				return reject(err);
			});
		});
	},
	getClientsByOfficeId: function getClientsByOfficeId(_ref2, officeId) {
		var commit = _ref2.commit;

		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_2__services_api_cabinets__["a" /* default */].getClientsByOfficeId(officeId).then(function (clients) {
				commit(__WEBPACK_IMPORTED_MODULE_1__types__["d" /* SET_CLIENTS_BY_OFFICEID */], { officeId: officeId, clients: clients });
				resolve();
			}).catch(function (err) {
				return reject(err);
			});
		});
	},
	getAdvisorsByOfficeId: function getAdvisorsByOfficeId(_ref3, officeId) {
		var commit = _ref3.commit;

		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_2__services_api_cabinets__["a" /* default */].getAdvisorsByOfficeId(officeId).then(function (advisors) {
				commit(__WEBPACK_IMPORTED_MODULE_1__types__["e" /* SET_ADVISORS_BY_OFFICEID */], { officeId: officeId, advisors: advisors });
				resolve();
			}).catch(function (err) {
				return reject(err);
			});
		});
	},
	getAdminByOfficeId: function getAdminByOfficeId(_ref4, officeId) {
		var commit = _ref4.commit;

		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_2__services_api_cabinets__["a" /* default */].getAdminByOfficeId(officeId).then(function (admin) {
				commit(__WEBPACK_IMPORTED_MODULE_1__types__["f" /* SET_ADMIN_BY_OFFICEID */], { officeId: officeId, admin: admin });
				resolve();
			}).catch(function (err) {
				return reject(err);
			});
		});
	},
	getCabinetById: function getCabinetById(_ref5, __id) {
		var commit = _ref5.commit;

		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_2__services_api_cabinets__["a" /* default */].getCabinetById(__id).then(function (cabinet) {
				resolve(cabinet);
			}).catch(function () {
				reject();
			});
		});
	},
	addCabinet: function addCabinet(_ref6, __cabinet) {
		var commit = _ref6.commit;

		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_2__services_api_cabinets__["a" /* default */].addCabinet(__cabinet).then(function (cabinet) {
				commit(__WEBPACK_IMPORTED_MODULE_1__types__["b" /* CREATE_CABINET */], { cabinet: cabinet });
				resolve();
			}).catch(function () {
				reject();
			});
		});
	},
	editCabinet: function editCabinet(_ref7, __cabinet) {
		var commit = _ref7.commit;

		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_2__services_api_cabinets__["a" /* default */].editCabinet(__cabinet).then(function (cabinet) {
				commit(__WEBPACK_IMPORTED_MODULE_1__types__["c" /* EDIT_CABINET */], { cabinet: cabinet });
				resolve();
			}).catch(function () {
				reject();
			});
		});
	}
};

/***/ }),
/* 470 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getters; });
var getters = {
	cabinets: function cabinets(state) {
		return state.cabinets;
	}
};

/***/ }),
/* 471 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state__ = __webpack_require__(473);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters__ = __webpack_require__(470);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(469);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mutations__ = __webpack_require__(472);





/* harmony default export */ __webpack_exports__["a"] = ({
	state: __WEBPACK_IMPORTED_MODULE_0__state__["a" /* state */],
	getters: __WEBPACK_IMPORTED_MODULE_1__getters__["a" /* getters */],
	actions: __WEBPACK_IMPORTED_MODULE_2__actions__["a" /* actions */],
	mutations: __WEBPACK_IMPORTED_MODULE_3__mutations__["a" /* mutations */]
});

/***/ }),
/* 472 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return mutations; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__types__ = __webpack_require__(202);




var _mutations;



var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__types__["a" /* SET_CABINETS */], function (state, cabinets) {
    state.cabinets = [].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(cabinets));
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__types__["b" /* CREATE_CABINET */], function (state, _ref) {
    var cabinet = _ref.cabinet;

    state.cabinets.push(cabinet);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__types__["c" /* EDIT_CABINET */], function (state, _ref2) {
    var cabinet = _ref2.cabinet;
    var cabinets = state.cabinets;

    state.cabinets.forEach(function (el, index) {
        if (cabinet.id === el.id) {
            cabinets[index] = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, cabinet);
        }
    });
    state.cabinets = [].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(cabinets));
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__types__["d" /* SET_CLIENTS_BY_OFFICEID */], function (state, _ref3) {
    var officeId = _ref3.officeId,
        clients = _ref3.clients;

    var officeIndex = state.cabinets.findIndex(function (office) {
        return office.id === officeId;
    });
    state.cabinets[officeIndex].clients = clients;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__types__["e" /* SET_ADVISORS_BY_OFFICEID */], function (state, _ref4) {
    var officeId = _ref4.officeId,
        advisors = _ref4.advisors;

    var officeIndex = state.cabinets.findIndex(function (office) {
        return office.id === officeId;
    });
    state.cabinets[officeIndex].advisors = advisors;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__types__["f" /* SET_ADMIN_BY_OFFICEID */], function (state, _ref5) {
    var officeId = _ref5.officeId,
        admin = _ref5.admin;

    var officeIndex = state.cabinets.findIndex(function (office) {
        return office.id === officeId;
    });
    state.cabinets[officeIndex].admin = admin;
}), _mutations);

/***/ }),
/* 473 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return state; });
var state = {
	cabinets: null
};

/***/ }),
/* 474 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return actions; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_api_clients__ = __webpack_require__(466);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_api_user__ = __webpack_require__(74);





var resolveDate = function resolveDate(date) {
	var d = null;
	if (date === null) {
		return null;
	}

	if (date.indexOf('-') !== -1) {
		d = date.split('-');
	} else {
		d = date.split('/');
	}
	if (d.length === 3) {
		if (d[2].toString().length === 4) {
			return d.join('-');
		} else {
			return d.reverse().join('-');
		}
	} else {
		return null;
	}
};

var actions = {
	getClients: function getClients(_ref) {
		var commit = _ref.commit;

		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_2__services_api_clients__["a" /* default */].getClients().then(function (clients) {
				commit(__WEBPACK_IMPORTED_MODULE_1__types__["a" /* SET_CLIENTS */], clients);
				resolve();
			}).catch(function () {
				reject();
			});
		});
	},
	getClientById: function getClientById(_ref2, __id) {
		var commit = _ref2.commit;

		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_2__services_api_clients__["a" /* default */].getClientById(__id).then(function (client) {
				commit(__WEBPACK_IMPORTED_MODULE_1__types__["b" /* SET_CLIENT */], client);
				resolve();
			}).catch(function () {
				reject();
			});
		});
	},
	addClient: function addClient(_ref3, __client) {
		var commit = _ref3.commit;

		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__client.birthdate = resolveDate(__client.birthdate);
			__WEBPACK_IMPORTED_MODULE_2__services_api_clients__["a" /* default */].addClient(__client).then(function (client) {
				commit(__WEBPACK_IMPORTED_MODULE_1__types__["c" /* CREATE_CLIENT */], { client: client });
				resolve();
			}).catch(function () {
				reject();
			});
		});
	},
	editClient: function editClient(_ref4, __client) {
		var commit = _ref4.commit;

		console.log('call edit client');
		__client.birthdate = resolveDate(__client.birthdate);
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_2__services_api_clients__["a" /* default */].editClient(__client).then(function (client) {
				console.log('return from edit client', client);
				commit(__WEBPACK_IMPORTED_MODULE_1__types__["d" /* EDIT_CLIENT */], { client: client });
				resolve();
			}).catch(function (error) {
				console.log(error);
				reject();
			});
		});
	},
	enableClient: function enableClient(_ref5, __id) {
		var commit = _ref5.commit;

		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_3__services_api_user__["a" /* default */].enableUser(__id).then(function () {
				commit('ENABLE_CLIENT', __id);
				resolve();
			}).catch(function () {
				reject();
			});
		});
	},
	disableClient: function disableClient(_ref6, __id) {
		var commit = _ref6.commit;

		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_3__services_api_user__["a" /* default */].disableUser(__id).then(function () {
				commit('DISABLE_CLIENT', __id);
				resolve();
			}).catch(function () {
				reject();
			});
		});
	},
	getClientEstateById: function getClientEstateById(_ref7, __id) {
		var commit = _ref7.commit;

		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_2__services_api_clients__["a" /* default */].getClientEstateById(__id).then(function (estate) {
				commit(__WEBPACK_IMPORTED_MODULE_1__types__["g" /* SET_ESTATE */], estate);
				resolve();
			}).catch(function () {
				reject();
			});
		});
	}
};

/***/ }),
/* 475 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getters; });
var getters = {
  estate: function estate(state) {
    return state.estate;
  },
  client: function client(state) {
    return state.client;
  },
  clients: function clients(state) {
    return state.clients;
  },
  getClientById: function getClientById(state) {
    return function (id) {
      return state.clients.find(function (client) {
        return client.id === id;
      });
    };
  }
};

/***/ }),
/* 476 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state__ = __webpack_require__(478);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters__ = __webpack_require__(475);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mutations__ = __webpack_require__(477);





/* harmony default export */ __webpack_exports__["a"] = ({
	state: __WEBPACK_IMPORTED_MODULE_0__state__["a" /* state */],
	getters: __WEBPACK_IMPORTED_MODULE_1__getters__["a" /* getters */],
	actions: __WEBPACK_IMPORTED_MODULE_2__actions__["a" /* actions */],
	mutations: __WEBPACK_IMPORTED_MODULE_3__mutations__["a" /* mutations */]
});

/***/ }),
/* 477 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return mutations; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__types__ = __webpack_require__(203);




var _mutations;



var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__types__["a" /* SET_CLIENTS */], function (state, clients) {
  state.clients = [].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(clients));
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__types__["b" /* SET_CLIENT */], function (state, client) {
  var advisor = {
    first_name: '',
    last_name: ''
  };
  state.client = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({ main_advisor: advisor }, client);
  if (!client.user.office) {
    state.client.user.office = {
      name: ''
    };
  }
  state.client.picture = client.user.media ? "https://api-preprod.patrimoffice.com/api/pictures/" + client.user.media.file : "https://api-preprod.patrimoffice.com/" + '/assets/user.png';
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__types__["c" /* CREATE_CLIENT */], function (state, _ref) {
  var client = _ref.client;

  state.clients.push(client);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__types__["d" /* EDIT_CLIENT */], function (state, _ref2) {
  var client = _ref2.client;

  state.clients.forEach(function (el, index) {
    if (client.id === el.id) {
      console.log(state.clients[index]);
      state.clients[index].user = client;
      state.client.user = client;
    }
  });
  state.clients = state.clients;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__types__["e" /* ENABLE_CLIENT */], function (state, id) {
  var target = state.clients.find(function (client) {
    return client.id === id;
  });
  target.enabled = true;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__types__["f" /* DISABLE_CLIENT */], function (state, id) {
  var target = state.clients.find(function (client) {
    return client.id === id;
  });
  target.enabled = false;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__types__["g" /* SET_ESTATE */], function (state, estate) {
  state.estate = estate;
}), _mutations);

/***/ }),
/* 478 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return state; });
var state = {
  client: null,
  estate: null,
  clients: null
};

/***/ }),
/* 479 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return actions; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_api_conseillers__ = __webpack_require__(467);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_api_user__ = __webpack_require__(74);





var actions = {
  getConseillers: function getConseillers(_ref) {
    var commit = _ref.commit;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_2__services_api_conseillers__["a" /* default */].getConseillers().then(function (conseillers) {
        commit(__WEBPACK_IMPORTED_MODULE_1__types__["a" /* GET_ADVISORS */], conseillers);
        resolve();
      }).catch(function () {
        reject();
      });
    });
  },
  getConseillerById: function getConseillerById(_ref2, __id) {
    var commit = _ref2.commit;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_2__services_api_conseillers__["a" /* default */].getConseillerById(__id).then(function (result) {
        commit(__WEBPACK_IMPORTED_MODULE_1__types__["f" /* SET_ADVISOR */], result.advisor);
        commit(__WEBPACK_IMPORTED_MODULE_1__types__["g" /* SET_CLIENTS */], result.clients);
        resolve();
      }).catch(function () {
        reject();
      });
    });
  },
  addConseiller: function addConseiller(_ref3, __conseiller) {
    var commit = _ref3.commit;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      resolve();
      __WEBPACK_IMPORTED_MODULE_2__services_api_conseillers__["a" /* default */].addConseiller(__conseiller).then(function (conseiller) {
        commit(__WEBPACK_IMPORTED_MODULE_1__types__["b" /* CREATE_ADVISOR */], conseiller);
        resolve();
      }).catch(function () {
        reject();
      });
    });
  },
  editConseiller: function editConseiller(_ref4, __conseiller) {
    var commit = _ref4.commit;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_2__services_api_conseillers__["a" /* default */].editConseiller(__conseiller).then(function (conseiller) {
        commit(__WEBPACK_IMPORTED_MODULE_1__types__["c" /* EDIT_ADVISOR */], { conseiller: conseiller });
        resolve();
      }).catch(function () {
        reject();
      });
    });
  },
  enableConseiller: function enableConseiller(_ref5, __id) {
    var commit = _ref5.commit;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_3__services_api_user__["a" /* default */].enableUser(__id).then(function () {
        commit('ENABLE_ADVISOR', __id);
        resolve();
      }).catch(function () {
        reject();
      });
    });
  },
  disableConseiller: function disableConseiller(_ref6, __id) {
    var commit = _ref6.commit;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_3__services_api_user__["a" /* default */].disableUser(__id).then(function () {
        commit('DISABLE_ADVISOR', __id);
        resolve();
      }).catch(function () {
        reject();
      });
    });
  },
  enableAdvisorClient: function enableAdvisorClient(_ref7, __id) {
    var commit = _ref7.commit;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_3__services_api_user__["a" /* default */].enableUser(__id).then(function () {
        commit('ENABLE_ADVISOR_CLIENT', __id);
        resolve();
      }).catch(function () {
        reject();
      });
    });
  },
  disableAdvisorClient: function disableAdvisorClient(_ref8, __id) {
    var commit = _ref8.commit;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_3__services_api_user__["a" /* default */].disableUser(__id).then(function () {
        commit('DISABLE_ADVISOR_CLIENT', __id);
        resolve();
      }).catch(function () {
        reject();
      });
    });
  }
};

/***/ }),
/* 480 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getters; });
var getters = {
	conseillers: function conseillers(state) {
		return state.conseillers;
	}
};

/***/ }),
/* 481 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state__ = __webpack_require__(483);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters__ = __webpack_require__(480);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(479);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mutations__ = __webpack_require__(482);





/* harmony default export */ __webpack_exports__["a"] = ({
	state: __WEBPACK_IMPORTED_MODULE_0__state__["a" /* state */],
	getters: __WEBPACK_IMPORTED_MODULE_1__getters__["a" /* getters */],
	actions: __WEBPACK_IMPORTED_MODULE_2__actions__["a" /* actions */],
	mutations: __WEBPACK_IMPORTED_MODULE_3__mutations__["a" /* mutations */]
});

/***/ }),
/* 482 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return mutations; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__types__ = __webpack_require__(204);




var _mutations;



var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__types__["a" /* GET_ADVISORS */], function (state, conseillers) {
  state.conseillers = [].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(conseillers));
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__types__["b" /* CREATE_ADVISOR */], function (state, conseiller) {
  state.conseillers.push(conseiller);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__types__["c" /* EDIT_ADVISOR */], function (state, _ref) {
  var conseiller = _ref.conseiller;
  var conseillers = state.conseillers;

  state.conseillers.forEach(function (el, index) {
    if (conseiller.id === el.id) {
      conseillers[index] = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, conseiller);
    }
  });
  state.conseillers = [].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(conseillers));
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__types__["d" /* ENABLE_ADVISOR */], function (state, id) {
  var target = state.conseillers.find(function (conseiller) {
    return conseiller.id === id;
  });
  target.enabled = true;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__types__["e" /* DISABLE_ADVISOR */], function (state, id) {
  var target = state.conseillers.find(function (conseiller) {
    return conseiller.id === id;
  });
  target.enabled = false;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__types__["f" /* SET_ADVISOR */], function (state, advisor) {
  state.advisor = advisor;
  state.advisor.office = advisor.office.name;
  state.advisor.picture = advisor.media ? "https://api-preprod.patrimoffice.com/api/pictures/" + advisor.media.file : "https://api-preprod.patrimoffice.com/" + '/assets/user.png';
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__types__["g" /* SET_CLIENTS */], function (state, clients) {
  state.clients = clients;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__types__["h" /* ENABLE_ADVISOR_CLIENT */], function (state, id) {
  var target = state.clients.find(function (client) {
    return client.user.id === id;
  });
  target.user.enabled = true;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__types__["i" /* DISABLE_ADVISOR_CLIENT */], function (state, id) {
  var target = state.clients.find(function (client) {
    return client.user.id === id;
  });
  target.user.enabled = false;
}), _mutations);

/***/ }),
/* 483 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return state; });
var state = {
  conseillers: null,
  advisor: null,
  clients: null
};

/***/ }),
/* 484 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getters; });
var getters = {
	isLoader: function isLoader(state) {
		return state.loader;
	}
};

/***/ }),
/* 485 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state__ = __webpack_require__(487);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters__ = __webpack_require__(484);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutations__ = __webpack_require__(486);




/* harmony default export */ __webpack_exports__["a"] = ({
	state: __WEBPACK_IMPORTED_MODULE_0__state__["a" /* state */],
	getters: __WEBPACK_IMPORTED_MODULE_1__getters__["a" /* getters */],
	mutations: __WEBPACK_IMPORTED_MODULE_2__mutations__["a" /* mutations */]
});

/***/ }),
/* 486 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return mutations; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types__ = __webpack_require__(488);


var _mutations;



var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__types__["a" /* LOADER_IN */], function (state) {
	state.loader = true;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__types__["b" /* LOADER_OUT */], function (state) {
	state.loader = false;
}), _mutations);

/***/ }),
/* 487 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return state; });
var state = {
	loader: false
};

/***/ }),
/* 488 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LOADER_IN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return LOADER_OUT; });
var LOADER_IN = 'LOADER_IN';
var LOADER_OUT = 'LOADER_OUT';

/***/ }),
/* 489 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return actions; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_api_user__ = __webpack_require__(74);




var actions = {
	fetchNotifications: function fetchNotifications(_ref, user) {
		var commit = _ref.commit;

		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_2__services_api_user__["a" /* default */].getNotifications(user.id).then(function (notifications) {
				commit(__WEBPACK_IMPORTED_MODULE_1__types__["a" /* FETCH_NOTIFICATIONS */], { notifications: notifications });
				resolve();
			}).catch(function () {
				reject();
			});
		});
	}
};

/***/ }),
/* 490 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getters; });
var getters = {
	notifications: function notifications(state) {
		return state.notifications;
	}
};

/***/ }),
/* 491 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state__ = __webpack_require__(493);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters__ = __webpack_require__(490);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(489);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mutations__ = __webpack_require__(492);





/* harmony default export */ __webpack_exports__["a"] = ({
	state: __WEBPACK_IMPORTED_MODULE_0__state__["a" /* state */],
	getters: __WEBPACK_IMPORTED_MODULE_1__getters__["a" /* getters */],
	actions: __WEBPACK_IMPORTED_MODULE_2__actions__["a" /* actions */],
	mutations: __WEBPACK_IMPORTED_MODULE_3__mutations__["a" /* mutations */]
});

/***/ }),
/* 492 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return mutations; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types__ = __webpack_require__(205);



var mutations = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_1__types__["a" /* FETCH_NOTIFICATIONS */], function (state, _ref) {
	var notifications = _ref.notifications;

	console.log(notifications);
	state.notifications = notifications;
});

/***/ }),
/* 493 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return state; });
var state = {
	notifications: null
};

/***/ }),
/* 494 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return actions; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_resources_Office__ = __webpack_require__(460);



var actions = {
	createOffice: function createOffice(_ref, data) {
		var commit = _ref.commit;

		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			console.log('===========DATA=============');
			console.log(data);
			console.log('========================');
			__WEBPACK_IMPORTED_MODULE_1__common_resources_Office__["a" /* default */].createOffice(data).then(function (response) {
				if (response.status === 200) {
					resolve(response.data);
				} else {
					reject(new Error('Une erreur est survenue'));
				}
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	updateOffice: function updateOffice(_ref2, data) {
		var commit = _ref2.commit;

		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1__common_resources_Office__["a" /* default */].updateOffice(data.id, data.payload).then(function (response) {
				if (response.status === 200) {
					resolve(response.data);
				} else {
					reject(new Error('Une erreur est survenue'));
				}
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	updateOfficeTheme: function updateOfficeTheme(_ref3, data) {
		var commit = _ref3.commit;

		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1__common_resources_Office__["a" /* default */].updateOfficeTheme(data.id, data.payload).then(function (response) {
				if (response.status === 200) {
					resolve(response.data);
				} else {
					reject(new Error('Une erreur est survenue'));
				}
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	updateOfficeHosts: function updateOfficeHosts(_ref4, data) {
		var commit = _ref4.commit;

		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			var formData = new FormData();
			data.payload.forEach(function (host, i) {
				formData.append('hosts[' + i + '][name]', host.name);
				formData.append('hosts[' + i + '][domain]', host.domain);
			});
			__WEBPACK_IMPORTED_MODULE_1__common_resources_Office__["a" /* default */].updateOfficeHosts(data.id, formData).then(function (response) {
				if (response.status === 200) {
					resolve(response.data);
				} else {
					reject(new Error('Une erreur est survenue'));
				}
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	updateOfficeLogo: function updateOfficeLogo(_ref5, data) {
		var commit = _ref5.commit;

		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			var formData = new FormData();
			formData.append('image', data.logo);
			__WEBPACK_IMPORTED_MODULE_1__common_resources_Office__["a" /* default */].updateOfficeLogo(data.id, formData).then(function (response) {
				if (response.status === 200) {
					resolve(response.data);
				} else {
					reject(new Error('Une erreur est survenue'));
				}
			}).catch(function (error) {
				reject(error);
			});
		});
	}
};

/***/ }),
/* 495 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getters; });
var getters = {};

/***/ }),
/* 496 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state__ = __webpack_require__(498);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters__ = __webpack_require__(495);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(494);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mutations__ = __webpack_require__(497);





/* harmony default export */ __webpack_exports__["a"] = ({
	state: __WEBPACK_IMPORTED_MODULE_0__state__["a" /* state */],
	getters: __WEBPACK_IMPORTED_MODULE_1__getters__["a" /* getters */],
	actions: __WEBPACK_IMPORTED_MODULE_2__actions__["a" /* actions */],
	mutations: __WEBPACK_IMPORTED_MODULE_3__mutations__["a" /* mutations */]
});

/***/ }),
/* 497 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return mutations; });

var mutations = {};

/***/ }),
/* 498 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return state; });
var state = {
	threads: []
};

/***/ }),
/* 499 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return actions; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_api_user__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_api_media__ = __webpack_require__(468);





var actions = {
    login: function login(_ref, __user) {
        var commit = _ref.commit;

        return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
            __WEBPACK_IMPORTED_MODULE_2__services_api_user__["a" /* default */].login(__user.email, __user.password).then(function (data) {
                commit(__WEBPACK_IMPORTED_MODULE_1__types__["b" /* LOGIN */], data);
                __WEBPACK_IMPORTED_MODULE_2__services_api_user__["a" /* default */].getUser().then(function (response) {
                    commit(__WEBPACK_IMPORTED_MODULE_1__types__["d" /* SET_USER */], response);
                    resolve();
                }).catch(function (error) {
                    reject(error);
                });
            }).catch(function (e) {
                reject(e);
            });
        });
    },
    logout: function logout(_ref2) {
        var commit = _ref2.commit,
            state = _ref2.state;

        return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
            __WEBPACK_IMPORTED_MODULE_2__services_api_user__["a" /* default */].logout().then(function () {
                commit(__WEBPACK_IMPORTED_MODULE_1__types__["c" /* LOGOUT */]);
                resolve();
            }).catch(function (error) {
                reject(error);
            });
        });
    },
    getUser: function getUser(_ref3) {
        var commit = _ref3.commit,
            state = _ref3.state;

        return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
            __WEBPACK_IMPORTED_MODULE_2__services_api_user__["a" /* default */].getUser().then(function (response) {
                commit(__WEBPACK_IMPORTED_MODULE_1__types__["d" /* SET_USER */], response);
                resolve();
            }).catch(function (error) {
                reject(error);
            });
        });
    },
    updateProfilePicture: function updateProfilePicture(_ref4, data) {
        var commit = _ref4.commit,
            state = _ref4.state;

        return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
            __WEBPACK_IMPORTED_MODULE_3__services_api_media__["a" /* default */].updateProfilePicture(data, state.user.id).then(function (response) {
                commit(__WEBPACK_IMPORTED_MODULE_1__types__["f" /* PROFIL_PICTURE */], response.data);
                resolve();
            }).catch(function (error) {
                reject(error);
            });
        });
    },
    saveProfile: function saveProfile(_ref5, data) {
        var commit = _ref5.commit;

        return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
            __WEBPACK_IMPORTED_MODULE_2__services_api_user__["a" /* default */].updateProfile(data).then(function (response) {
                commit(__WEBPACK_IMPORTED_MODULE_1__types__["e" /* UPDATE_PROFILE */], data);
                resolve();
            }).catch(function (error) {
                reject(error);
            });
        });
    },
    editPassword: function editPassword(_ref6, data) {
        var commit = _ref6.commit;

        return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
            __WEBPACK_IMPORTED_MODULE_2__services_api_user__["a" /* default */].editPassword(data).then(function (response) {
                if (response.status === 201) {
                    resolve(response);
                } else {
                    reject(new Error());
                }
            }).catch(function (error) {
                reject(error);
            });
        });
    }
};

/***/ }),
/* 500 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getters; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);


var getters = {
  isAuthenticated: function isAuthenticated(state) {
    return state.token !== null;
  },
  isSuperAdmin: function isSuperAdmin(state) {
    return state.roles.indexOf("ROLE_SUPER_ADMIN") !== -1;
  },
  user: function user(state) {
    return state;
  },
  officeId: function officeId(state) {
    return state.officeId;
  },
  isTokenExpired: function isTokenExpired(state) {
    return state.token_duration && __WEBPACK_IMPORTED_MODULE_0_moment___default()(state.token_duration) <= __WEBPACK_IMPORTED_MODULE_0_moment___default()();
  }
};

/***/ }),
/* 501 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state__ = __webpack_require__(503);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters__ = __webpack_require__(500);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(499);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mutations__ = __webpack_require__(502);





/* harmony default export */ __webpack_exports__["a"] = ({
	state: __WEBPACK_IMPORTED_MODULE_0__state__["a" /* state */],
	getters: __WEBPACK_IMPORTED_MODULE_1__getters__["a" /* getters */],
	actions: __WEBPACK_IMPORTED_MODULE_2__actions__["a" /* actions */],
	mutations: __WEBPACK_IMPORTED_MODULE_3__mutations__["a" /* mutations */]
});

/***/ }),
/* 502 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return mutations; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);


var _mutations;




var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__types__["a" /* SET_TOKENS */], function (state, data) {
  state.token = data.token;
  state.refresh = data.refresh_token;

  state.token_duration = __WEBPACK_IMPORTED_MODULE_2_moment___default()().add("1200", 'seconds').format();
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__types__["b" /* LOGIN */], function (state, data) {
  state.token = data.token;
  state.refresh = data.refresh_token;
  state.id = data.user.id;
  state.user = data.user;
  state.roles = data.user.roles;
  state.officeId = data.user.office.id;

  state.token_duration = __WEBPACK_IMPORTED_MODULE_2_moment___default()().add("1200", 'seconds').format();
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__types__["c" /* LOGOUT */], function (state) {
  state.user = null;
  state.token = null;
  state.refresh = null;
  state.id = null;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__types__["d" /* SET_USER */], function (state, data) {
  state.firstname = data.first_name;
  state.lastname = data.last_name;
  state.email = state.user.email;
  state.address = {
    line: data.line,
    zip: data.zip,
    city: data.city,
    country: data.country
  };
  state.phone = data.phone;
  state.picture = data.media ? "https://api-preprod.patrimoffice.com/api/pictures/" + data.media.file : "https://api-preprod.patrimoffice.com/" + '/assets/user.png';
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__types__["e" /* UPDATE_PROFILE */], function (state, data) {
  state.firstname = data.firstname;
  state.lastname = data.lastname;
  state.email = data.email;
  state.address = {
    line: data.address.line,
    zip: data.address.zip,
    city: data.address.city,
    country: data.address.country
  };
  state.phone = data.phone;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__types__["f" /* PROFIL_PICTURE */], function (state, data) {
  state.picture = data.image;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__types__["g" /* GET_ADVISORS */], function (state, data) {
  state.advisors = data || [];
}), _mutations);

/***/ }),
/* 503 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return state; });
var state = {
  token: null,
  refresh: null,
  firstname: null,
  lastname: null,
  email: null,
  address: null,
  phone: null,
  picture: null,
  user: null,
  roles: null,
  officeId: null,
  token_duration: null
};

/***/ }),
/* 504 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ROLES; });
var ROLES = [{ key: "ROLE_CLIENT", label: "Client" }, { key: "ROLE_ADVISOR", label: "Conseiller" }, { key: "ROLE_ADMIN", label: "Administrateur" }];

/***/ }),
/* 505 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  watch: {
    isAuthenticated: function isAuthenticated(_isAuthenticated) {
      if (!this.isAuthenticated) {
        this.$router.push({ name: 'Login' });
      }
    }
  },
  computed: {
    isAuthenticated: function isAuthenticated() {
      return this.$store.getters.isAuthenticated;
    }
  }
});

/***/ }),
/* 506 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'custom-select',
	props: ['value', 'items', 'selected', 'solo', 'object'],
	data: function data() {
		return {
			select: null,
			show: false
		};
	},
	mounted: function mounted() {
		if (this.selected) {
			this.select = this.selected.type || this.selected;
		} else {
			this.select = this.value || null;
		}
	},

	methods: {
		setSelect: function setSelect(key) {
			this.select = this.items[key].type || this.items[key];
			this.show = false;
			this.$emit('change', this.items[key]);
			this.$emit('input', this.items[key]);
		},
		display: function display() {
			this.show = !this.show;
			if (this.show) {
				window.addEventListener('click', this.checkClick);
			}
		},
		checkClick: function checkClick(e) {
			this.show = false;
			window.removeEventListener('click', this.checkClick);
		}
	},
	watch: {
		selected: function selected(value) {
			this.select = value.type || value;
		},
		value: function value(_value) {
			this.select = _value;
		}
	}
});

/***/ }),
/* 507 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'radio-box',
	props: ['value'],
	data: function data() {
		return {
			val: false
		};
	},
	mounted: function mounted() {
		this.val = this.value;
	},

	methods: {
		change: function change() {
			this.val = !this.val;
			this.$emit('change', this.val);
		}
	}
});

/***/ }),
/* 508 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_ag_grid_vue__ = __webpack_require__(418);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_ag_grid_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_ag_grid_vue__);




/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'ag-table',
	props: ['columns', 'rows', 'customOptions'],
	components: {
		AgGridVue: __WEBPACK_IMPORTED_MODULE_1_ag_grid_vue__["AgGridVue"]
	},
	data: function data() {
		return {
			defaultOptions: {
				paginationPageSize: 10,
				suppressPaginationPanel: true,
				headerHeight: 50,
				rowHeight: 50,
				pagination: false,
				onRowClicked: this.onRowClicked,
				onCellClicked: this.onCellClicked,
				localeText: {
					noRowsToShow: 'Vous n\'avez encore aucun client'
				},
				onComponentStateChanged: this.afterReady,
				onGridReady: this.afterReady,
				onBodyScroll: this.afterReady,
				onPaginationChanged: this.afterReady
			},
			gridOptions: null,
			showGrid: false
		};
	},

	methods: {
		afterReady: function afterReady() {
			var imgs = document.querySelectorAll('.ag-root-wrapper .ctn-profile-picture img');
			imgs.forEach(function (img) {
				var tmp = new Image();
				tmp.addEventListener('load', function () {
					img.classList.add(tmp.width > tmp.height ? 'landscape' : 'portrait');
					img.classList.remove(tmp.width > tmp.height ? 'portrait' : 'landscape');
				});
				tmp.src = img.src;
			});
		},
		rendering: function rendering() {
			var _this = this;

			return {
				dateFormat: function dateFormat(params) {
					var foo = _this.$moment(params.value);
					return '<div class="custom-cell"><span class="bold">' + foo.format('DD MMMM YYYY') + '</span> <span class="light">' + foo.format('dddd') + '</span></div>';
				},
				shortDateFormat: function shortDateFormat(params) {
					return '<div class="custom-cell no-upper light">' + _this.$moment(params.value).format('DD/MM/YYYY') + '</div>';
				},
				rangeHourFormat: function rangeHourFormat(params) {
					var start = _this.$moment(params.value.start);
					var end = _this.$moment(params.value.end);
					return '<div class="custom-cell no-upper no-margin"><span class="light">de </span><span class="bold">' + start.format('H') + 'h </span><span class="light">\xE0 </span><span class="bold">' + end.format('H') + 'h</span></div>';
				},
				cabinetFormat: function cabinetFormat(params) {
					var _params$value = params.value,
					    text = _params$value.text,
					    color = _params$value.color;

					return '<div class="custom-cell no-margin"><span class="pastille" style="background-color: ' + color + ';"></span><span class="bold">' + text + '</span></div>';
				},
				typeActivityFormat: function typeActivityFormat(params) {
					var label = null;
					var color = null;
					if (params.value === 'appointment') {
						label = 'Rendez-vous';
						color = 'red';
					} else {
						label = 'Visio Call';
						color = 'brown';
					}

					return '<div class="custom-cell no-margin"><span class="pastille ' + color + '"></span><span class="bold">' + label + '</span></div>';
				},
				statusAvailableFormat: function statusAvailableFormat(params) {
					var cssClass = '';
					if (params.value) {
						cssClass = 'active';
					}
					return '<div class="custom-cell no-margin">\n\t\t\t\t\t\t\t\t<div class="toggle-input ' + cssClass + '">\n\t\t\t\t\t\t\t\t\t<div class="button"></div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>';
				},
				statusActivityFormat: function statusActivityFormat(params) {
					var cssClass = null;
					var label = null;
					if (params.value === 'confirmed') {
						cssClass = 'green';
						label = 'Confirmé';
					} else if (params.value === 'waiting') {
						cssClass = 'orange';
						label = 'En attente';
					} else {
						label = '-';
					}

					return '<div class="custom-cell no-margin"><span class="bold ' + cssClass + '">' + label + '</span></div>';
				},
				roundImgFormat: function roundImgFormat(params) {
					var img = params.data.media && params.data.media.file ? "https://api-preprod.patrimoffice.com/api/pictures/" + params.data.media.file : "https://api-preprod.patrimoffice.com/" + 'assets/user.png';
					return '<div class="custom-cell ctn-profile-picture"><img src="' + img + '"></div>';
				},
				typeContactFormat: function typeContactFormat(params) {
					var label = params.value === 'client_subscriber' ? 'Abonné' : 'Prospect';
					return _this.rendering().lightFormat({ value: label });
				},
				lightFormat: function lightFormat(params) {
					return '<div class="custom-cell"><div class="light">' + (params.value || '-') + '</div></div>';
				},
				noUpperFormat: function noUpperFormat(params) {
					return '<div class="custom-cell no-upper">' + (params.value || '-') + '</div>';
				},
				currentTaskFormat: function currentTaskFormat(params) {
					var label = _this.taskResolver(params.value);
					return _this.rendering().lightFormat({ value: label });
				},
				arrayFormat: function arrayFormat(params) {
					return '<div class="custom-cell"><div class="light">' + params.value.length + '</div></div>';
				},
				bellCellFormat: function bellCellFormat(params) {
					var bell = null;
					if (params.value) {
						bell = params.value === 'warn' ? 'yellow' : 'red';
					} else {
						return '<div></div>';
					}

					return '<div class="custom-cell ' + bell + '"><span class="icon-alert"></span></div>';
				},
				compactNameFormat: function compactNameFormat(params) {
					return params.data.firstname + ' ' + params.data.lastname;
				},
				statusMissionFormat: function statusMissionFormat(params) {
					return _this.statusMissionResolver(params.value);
				}
			};
		},

		statusMissionResolver: function statusMissionResolver(value) {
			var foo = '<div class="custom-cell status-missions row ';
			switch (value) {
				case 'En Attente':
					foo += 'orange"><div class="ctn-icon"><span class="icon-volet-notif"></span></div>';
					break;
				case 'Signé':
					foo += 'green"><div class="ctn-icon"></div>';
			}
			return foo + '<div class="light">' + value + '</div></div>';
		},
		taskResolver: function taskResolver(value) {
			var foo = null;
			switch (value) {
				case 'active_contract':
					foo = 'Contrat actif';
					break;
				case 'report_to_sign':
					foo = 'Compte rendu de mission à signer';
					break;
				case 'contract_check':
					foo = 'Contrat à valider';
					break;
				case 'heritage_landscape_to_complete':
					foo = 'Paysage Patrimonial à completer';
					break;
				case 'project_to_validate':
					foo = 'Projet d\'investissement à valider';
					break;
				default:
					foo = '-';
			}
			return foo;
		},
		onReady: function onReady() {
			this.showGrid = true;
		},
		onRowClicked: function onRowClicked(e) {
			this.$emit('rowclick', e);
		},
		onCellClicked: function onCellClicked(e) {
			this.$emit('cellclick', e);
		}
	},
	computed: {
		paginationPageSize: {
			get: function get() {
				if (this.options && this.options.api) {
					return this.options.api.paginationGetPageSize();
				}
			},
			set: function set(newValue) {
				if (this.options && this.options.api) {
					this.options.api.paginationSetPageSize(newValue);
				}
			}
		},
		currentPage: {
			get: function get() {
				if (this.options && this.options.api) {
					var totalPages = this.options.api.paginationGetTotalPages();
					var pageIndex = this.options.api.paginationGetCurrentPage() + 1;
					if (pageIndex <= 0) {
						return 1;
					} else if (pageIndex > totalPages) {
						return totalPages;
					}
					return pageIndex;
				}
			},
			set: function set(newValue) {
				if (this.options && this.options.api) {
					var totalPages = this.options.api.paginationGetTotalPages();
					if (newValue <= totalPages && newValue > 0) {
						this.options.api.paginationGoToPage(newValue - 1);
					}
				}
			}
		},
		columnsComputed: function columnsComputed() {
			var _this2 = this;

			var foo = [];
			this.columns.forEach(function (column) {
				foo.push({
					headerName: column.name,
					field: column.field,
					cellRenderer: _this2.rendering()[column.cellType + 'Format']
				});

				if (column.width) {
					foo[foo.length - 1].width = column.width;
				}

				if (column.cellClass) {
					foo[foo.length - 1].cellClass = column.cellClass;
				}
			});
			return foo;
		},
		options: function options() {
			if (this.customOptions) {
				return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.defaultOptions, this.customOptions);
			} else {
				return this.defaultOptions;
			}
		}
	}
});

/***/ }),
/* 509 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'baseModal',
	props: ['show', 'content', 'data', 'disableClickOutside'],
	data: function data() {
		return {
			launch: false,
			realLaunch: false
		};
	},
	mounted: function mounted() {
		if (this.show) {
			this.launch = true;
			this.realLaunch = true;
		}
	},

	methods: {
		close: function close() {
			this.$emit('close');
		},
		closeFromOutside: function closeFromOutside() {
			if (!this.disableClickOutside) {
				this.close();
			}
		}
	},
	watch: {
		show: function show(value) {
			var _this = this;

			if (value) {
				this.realLaunch = true;
				window.setTimeout(function () {
					_this.launch = true;
				}, 10);
			} else {
				window.setTimeout(function () {
					_this.launch = false;
				}, 10);
				window.setTimeout(function () {
					_this.realLaunch = false;
				}, 510);
			}
		}
	}
});

/***/ }),
/* 510 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Form_CustomSelect__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Form_CustomSelect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Form_CustomSelect__);




/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'DomainSelector',
	props: ['domainInfo', 'index', 'domainTypes'],
	components: { CustomSelect: __WEBPACK_IMPORTED_MODULE_0__Form_CustomSelect___default.a },
	data: function data() {
		return {
			domainType: null,
			domain: this.domainInfo.host
		};
	},
	beforeMount: function beforeMount() {
		if (this.domainInfo) {
			this.domainType = this.domainInfo.type;
			this.domain = this.domainInfo.domain;
		}
	},

	methods: {
		domainUpdated: function domainUpdated() {
			this.$emit('domainUpdated', {
				index: this.index,
				domainInfo: { domain: this.domain, name: this.domainType.name }
			});
		}
	},
	watch: {
		domainType: function domainType(value) {
			this.domainUpdated();
		}
	}
});

/***/ }),
/* 511 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(30);





/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'loader',
	mounted: function mounted() {
		this.$store.commit('LOADER_OUT');
	},

	computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])({
		loader: 'isLoader'
	}))
});

/***/ }),
/* 512 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'toggle-input',
	props: ['value'],
	data: function data() {
		return {
			custom: false
		};
	},
	mounted: function mounted() {
		this.custom = this.value;
	},

	methods: {
		changeValue: function changeValue() {
			this.custom = !this.custom;
			this.$emit('change', this.custom);
		}
	}
});

/***/ }),
/* 513 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(30);




/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'my-header',
	data: function data() {
		return {
			show: this.isSuperAdmin,
			menu: [{
				key: 0,
				name: '<span class="icon-nav-admin-conseiller"></span> Conseillers',
				uri: 'Conseillers',
				visibleForAdmin: true
			}, {
				key: 1,
				name: '<span class="icon-nav-admin-clients"></span> Clients',
				uri: 'Clients',
				visibleForAdmin: true
			}, {
				key: 2,
				name: '<span class="icon-nav-admin-cabinets"></span> Cabinets',
				uri: 'Cabinets',
				visibleForAdmin: false
			}],
			notifs: [{
				key: 0
			}]
		};
	},

	methods: {
		setActive: function setActive() {
			this.$emit('notif-open');
		}
	},
	computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapState */])({
		picture: function picture(state) {
			return state.users.picture;
		}
	}), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])({
		count: 'count',
		isSuperAdmin: 'isSuperAdmin'
	}))
});

/***/ }),
/* 514 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'ChangePassword',
	data: function data() {
		return {
			password: null,
			newPassword1: null,
			newPassword2: null
		};
	},

	methods: {
		close: function close() {
			this.$emit('close');
		},
		confirm: function confirm() {
			var _this = this;

			this.$validator.validate().then(function (validation) {
				if (validation && _this.newPassword1 === _this.newPassword2) {
					var data = new FormData();
					data.append('current_password', _this.password);
					data.append('plain_password[first]', _this.newPassword1);
					data.append('plain_password[second]', _this.newPassword2);
					_this.$store.dispatch('editPassword', data).then(function (result) {
						_this.$notify({
							type: 'success',
							group: 'default',
							title: 'Votre mot de passe a été changé',
							text: ''
						});
						_this.$emit('close');
					}).catch(function (error) {
						console.log(error);
						_this.$notify({
							type: 'error',
							group: 'default',
							title: 'Le changement de mot de passe a échoué',
							text: 'Vous vous êtes peut être trompé dans le mot de passe'
						});
					});
				}
			});
		}
	}
});

/***/ }),
/* 515 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(30);




/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'NotificationPanel',
	props: ['active'],
	methods: {
		setActive: function setActive() {
			this.$emit('notif-close');
		}
	},
	computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])({
		notifications: 'notifications'
	}))
});

/***/ }),
/* 516 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_components_ag_table__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_components_ag_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__common_components_ag_table__);




/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'Activity',
	props: ['elements', 'clickable'],
	components: {
		AgTable: __WEBPACK_IMPORTED_MODULE_1__common_components_ag_table___default.a
	},
	data: function data() {
		return {
			columnDefs: null,
			rowData: this.elements,
			tableOptions: {
				pagination: false,
				headerHeight: 30,
				rowHeight: 44
			}
		};
	},
	beforeMount: function beforeMount() {
		this.columnDefs = [{ name: 'Nom', field: 'name' }, { name: 'Admin', field: 'adminFullName', cellType: 'light' }, { name: 'Début du contrat', field: 'contract_start_date', cellType: 'shortDate' }, { name: 'Fin du contrat', field: 'contract_end_date', cellType: 'shortDate' }, { name: 'Conseillers', field: 'numberOfAdvisors', cellType: 'number', width: 180 }, { name: 'Clients', field: 'numberOfClients', cellType: 'number', width: 180 }, { name: 'Statut', field: 'enabled', cellType: 'statusAvailable', width: 80 }];
	},

	methods: {
		handleCellClick: function handleCellClick(e) {
			if (e.colDef.headerName === 'Statut') {
				this.$emit('statuschange', e);
			} else if (this.clickable && e.data && e.data.id) {
				this.$router.push({ name: 'CabinetsDetails', params: { id: e.data.id } });
			} else if (!this.clickable && e.data && e.data.id) {
				this.$emit('editCabinet', e);
			}
		}
	},
	computed: {
		rowDataFiltered: function rowDataFiltered() {
			var _this = this;

			return this.elements.map(function (office) {
				var filteredOffice = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, office);
				var format = 'DD/MM/YYYY h:mm';
				filteredOffice.contract_start_date = _this.$moment(office.contract_start_date, format).toISOString();
				filteredOffice.contract_end_date = _this.$moment(office.contract_end_date, format).toISOString();
				filteredOffice.numberOfClients = office.clients.length;
				filteredOffice.numberOfAdvisors = office.advisors.length;
				filteredOffice.adminFullName = office.admin.length === 0 ? null : office.admin[0].first_name + ' ' + office.admin[0].last_name;
				return filteredOffice;
			});
		}
	}
});

/***/ }),
/* 517 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modals_CabinetModal__ = __webpack_require__(617);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modals_CabinetModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__modals_CabinetModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_components_baseModal__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_components_baseModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__common_components_baseModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__CabinetsTable__ = __webpack_require__(615);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__CabinetsTable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__CabinetsTable__);











/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'Cabinets',
	components: {
		Table: __WEBPACK_IMPORTED_MODULE_7__CabinetsTable___default.a,
		baseModal: __WEBPACK_IMPORTED_MODULE_6__common_components_baseModal___default.a
	},
	data: function data() {
		return {
			showAddCabinet: false,
			currentCabinet: null,
			contentModal: __WEBPACK_IMPORTED_MODULE_5__modals_CabinetModal___default.a
		};
	},
	beforeRouteEnter: function beforeRouteEnter(to, from, next) {
		__WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].commit('LOADER_IN');
		__WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].dispatch('getCabinets').then(function () {
			var getClientsPromises = __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].getters.cabinets.map(function (office) {
				return __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].dispatch('getClientsByOfficeId', office.id);
			});
			var getAdvisorsPromises = __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].getters.cabinets.map(function (office) {
				return __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].dispatch('getAdvisorsByOfficeId', office.id);
			});
			var getAdminPromises = __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].getters.cabinets.map(function (office) {
				return __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].dispatch('getAdminByOfficeId', office.id);
			});
			return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.all([].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(getClientsPromises), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(getAdvisorsPromises), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(getAdminPromises)));
		}).then(function () {
			next();
		}).catch(function () {
			next(false);
		}).finally(function () {
			__WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].commit('LOADER_OUT');
		});
	},

	methods: {
		showNewCabinet: function showNewCabinet() {
			this.currentCabinet = null;
			this.showAddCabinet = true;
		},
		editCabinet: function editCabinet(element) {
			var value = element.value,
			    rowIndex = element.rowIndex;

			var cabinet = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.cabinets[rowIndex], { available: !value });
			console.log(cabinet);
			this.currentCabinet = cabinet;
			this.showAddCabinet = true;
		},
		updateStatus: function updateStatus(e) {
			var value = e.value,
			    rowIndex = e.rowIndex;

			var cabinet = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.cabinets[rowIndex], { available: !value });
			this.$store.dispatch('editCabinet', cabinet);
		}
	},
	computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapGetters */])({
		cabinets: "cabinets"
	}))
});

/***/ }),
/* 518 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__ = __webpack_require__(533);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_color__ = __webpack_require__(609);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_color___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_color__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_components_domain_selector__ = __webpack_require__(611);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_components_domain_selector___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__common_components_domain_selector__);






var DEFAULT_CABINET = {
	name: null
};
/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'AddCabinet',
	components: { DomainSelector: __WEBPACK_IMPORTED_MODULE_3__common_components_domain_selector___default.a, 'chrome-color-picker': __WEBPACK_IMPORTED_MODULE_2_vue_color__["Chrome"] },
	props: ['data'],
	data: function data() {
		return {
			colorPickerPosition: { x: 0, y: 0 },
			colors: '',
			theme: {
				name: 'colors',
				colors: {
					primary: '#262a3e',
					secondary: '#b22222'
				}
			},
			logo: null,
			logoUrl: null,
			currentThemeColorSelected: null,
			adminOptions: [],
			cabinet: DEFAULT_CABINET,
			domains: [{
				type: null,
				domain: ''
			}],
			domainTypes: [{
				label: 'Site vitrine',
				name: 'app'
			}, {
				label: 'Backoffice',
				name: 'admin'
			}, {
				label: 'Cgpi',
				name: 'cgpi'
			}, {
				label: 'Client',
				name: 'client'
			}]
		};
	},
	beforeMount: function beforeMount() {
		var _this = this;

		this.$store.dispatch('getConseillers').then(function () {
			_this.adminOptions = _this.$store.getters['conseillers'].filter(function (conseiller) {
				return conseiller.role === "Admin";
			}).map(function (conseiller) {
				return conseiller.name;
			});
		});
		if (this.data) {
			if (this.data.currentCabinet) {
				this.fillForm();
			} else {
				this.cabinet = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, DEFAULT_CABINET);
			}
		} else {
			this.cabinet = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, DEFAULT_CABINET);
		}
	},
	mounted: function mounted() {
		if (this.data.currentCabinet == null) {
			this.cabinet = {};
		}
		console.log(this.generateThemePayload());
	},

	methods: {
		getFile: function getFile(e) {
			var files = e.target.files || e.dataTransfer.files;
			if (!files.length) {
				this.logo = null;
				this.logoUrl = null;
				return;
			}
			this.logo = files[0];
			this.readURL(files[0]);
		},
		readURL: function readURL(file) {
			var _this2 = this;

			var reader = new FileReader();

			reader.onload = function (e) {
				_this2.logoUrl = e.target.result;
				console.log(_this2.logoUrl);
			};

			reader.readAsDataURL(file);
		},
		fillForm: function fillForm() {
			var _this3 = this;

			this.cabinet.name = this.data.currentCabinet.name;
			this.cabinet.email = this.data.currentCabinet.email;
			this.cabinet.wordpressSite = this.data.currentCabinet.wordpress_site;
			this.domains.pop();
			if (this.data.currentCabinet.client_subdomain) {
				this.domains.push({
					type: { label: 'Client', name: 'client' },
					domain: this.data.currentCabinet.client_subdomain
				});
			}
			if (this.data.currentCabinet.cgpi_subdomain) {
				this.domains.push({
					type: { label: 'Cgpi', name: 'cgpi' },
					domain: this.data.currentCabinet.cgpi_subdomain
				});
			}
			if (this.data.currentCabinet.admin_subdomain) {
				this.domains.push({
					type: { label: 'Backoffice', name: 'admin' },
					domain: this.data.currentCabinet.admin_subdomain
				});
			}
			if (this.data.currentCabinet.app_subdomain) {
				this.domains.push({
					type: { label: 'Site Vitrine', name: 'app' },
					domain: this.data.currentCabinet.app_subdomain
				});
			}
			var primary = this.data.currentCabinet.theme.params.find(function (param) {
				return param.param_name === 'primary';
			});
			var secondary = this.data.currentCabinet.theme.params.find(function (param) {
				return param.param_name === 'secondary';
			});
			this.theme.colors.primary = primary.param_value;
			this.theme.colors.secondary = secondary.param_value;

			if (this.data.currentCabinet.theme.logo) {
				var filename = this.data.currentCabinet.theme.logo.file;
				this.logoUrl = "https://api-preprod.patrimoffice.com/" + 'api/office-asset/' + filename;
				fetch(this.logoUrl).then(function (response) {
					response.blob().then(function (blob) {
						_this3.logo = new File([blob], filename, { type: blob.type });
						_this3.readURL(_this3.logo);
					});
				});
			}
		},
		addDomain: function addDomain() {
			if (this.domains.length >= 4) {
				return;
			}
			this.domains.push({
				name: null,
				domain: ''
			});
		},
		deleteDomainAt: function deleteDomainAt(index) {
			this.domains.splice(index, 1);
		},
		deleteDomain: function deleteDomain() {
			this.domains.pop();
		},
		updateDomain: function updateDomain(data) {
			this.domains[data.index] = data.domainInfo;
		},
		toggleColorPicker: function toggleColorPicker(event, colorType) {
			this.colorPickerPosition.x = event.pageX;

			this.colorPickerPosition.y = event.pageY;

			this.currentThemeColorSelected = colorType;

			var currentColor = this.theme.colors[colorType];

			if (currentColor) {
				this.colors = currentColor;
			}
		},
		onClickOutside: function onClickOutside(event) {
			if (!event.target.className.includes('toggle-dropdown') && !event.target.className.includes('color-toggle') && !event.target.className.includes('fa-angle-down')) {
				this.currentThemeColorSelected = null;
				this.colors = '';
			}
		},
		close: function close() {
			this.cabinet = DEFAULT_CABINET;
			this.$emit('close');
		},
		submit: function submit() {
			if (this.data.currentCabinet) {
				this.submitUpdate();
			} else {
				this.submitCreation();
			}
		},
		submitCreation: function submitCreation() {
			var _this4 = this;

			this.$store.commit('LOADER_IN');
			this.$store.dispatch('createOffice', this.cabinet).then(function (office) {
				_this4.$store.dispatch('updateOfficeHosts', { id: office.id, payload: _this4.domains }).then(function () {
					_this4.$store.dispatch('updateOfficeTheme', { id: office.id, payload: _this4.generateThemePayload() }).then(function () {
						_this4.$store.dispatch('updateOfficeLogo', { id: office.id, logo: _this4.logo }).then(function () {
							_this4.close();
							_this4.cabinet = DEFAULT_CABINET;
							_this4.$store.commit('LOADER_OUT');
						}).catch(function () {
							return _this4.$store.commit('LOADER_OUT');
						});
					}).catch(function () {
						return _this4.$store.commit('LOADER_OUT');
					});
				}).catch(function () {
					return _this4.$store.commit('LOADER_OUT');
				});
			}).catch(function () {
				return _this4.$store.commit('LOADER_OUT');
			});
		},
		submitUpdate: function submitUpdate() {
			var _this5 = this;

			this.$store.commit('LOADER_IN');
			this.$store.dispatch('updateOffice', { id: this.data.currentCabinet.id, payload: this.cabinet }).then(function () {
				_this5.$store.dispatch('updateOfficeHosts', { id: _this5.data.currentCabinet.id, payload: _this5.domains }).then(function () {
					_this5.$store.dispatch('updateOfficeTheme', { id: _this5.data.currentCabinet.id, payload: _this5.generateThemePayload() }).then(function () {
						_this5.$store.dispatch('updateOfficeLogo', { id: _this5.data.currentCabinet.id, logo: _this5.logo }).then(function () {
							_this5.close();
							_this5.cabinet = DEFAULT_CABINET;
							_this5.$store.commit('LOADER_OUT');
						}).catch(function () {
							return _this5.$store.commit('LOADER_OUT');
						});
					}).catch(function () {
						return _this5.$store.commit('LOADER_OUT');
					});
				}).catch(function () {
					return _this5.$store.commit('LOADER_OUT');
				});
			}).catch(function () {
				return _this5.$store.commit('LOADER_OUT');
			});
		},
		generateThemePayload: function generateThemePayload() {
			var payload = {
				name: this.theme.name
			};

			var params = [];

			__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default()(this.theme.colors).forEach(function (keyValue) {
				var currentParams = {};
				currentParams.paramName = keyValue[0];
				currentParams.paramValue = keyValue[1];
				params.push(currentParams);
			});

			payload.params = params;

			return payload;
		},
		validateBeforeSubmit: function validateBeforeSubmit() {
			var _this6 = this;

			this.$validator.validateAll().then(function (result) {
				if (result) {
					_this6.submit();
					return;
				}
			});
		}
	},
	computed: {
		availableDomainTypes: function availableDomainTypes() {
			var usedDomanTypesName = this.domains.map(function (domainInfo) {
				return domainInfo.name;
			});

			return this.domainType.filter(function (domainType) {
				return !usedDomanTypesName.includes(domainType.name);
			});
		}
	},
	watch: {
		colors: function colors(value) {
			if (!this.currentThemeColorSelected || !value) {
				return;
			}

			var newColorValue = typeof value.hex8 !== 'undefined' ? value.hex8 : value;

			console.log(newColorValue);

			this.theme.colors[this.currentThemeColorSelected] = newColorValue;
		}
	}
});

/***/ }),
/* 519 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_components_ag_table__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_components_ag_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__common_components_ag_table__);




/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'Activity',
	props: ['elements', 'clickable'],
	components: {
		AgTable: __WEBPACK_IMPORTED_MODULE_1__common_components_ag_table___default.a
	},
	data: function data() {
		return {
			columnDefs: null,
			rowData: this.elements,
			tableOptions: {
				pagination: false,
				headerHeight: 30,
				rowHeight: 44
			}
		};
	},
	beforeMount: function beforeMount() {
		this.columnDefs = [{ name: 'Pic-id', field: 'picture', cellType: 'roundImg', width: 80 }, { name: 'Nom', field: 'name', width: 150 }, { name: 'Cabinet', field: 'office.name', width: 120 }, { name: 'E-mail', field: 'email', cellType: 'light', width: 250 }, { name: 'Téléphone', field: 'phone', cellType: 'light', width: 120 }, { name: 'Adresse', field: 'address', cellType: 'light', width: 150 }, { name: 'Ville', field: 'city', cellType: 'light', width: 100 }, { name: 'Pays', field: 'country', cellType: 'light', width: 100 }, { name: 'Conseiller', field: 'advisor', width: 100 }, { name: 'Statut', field: 'enabled', cellType: 'statusAvailable', width: 100 }];
	},

	methods: {
		handleCellClick: function handleCellClick(e) {
			console.log(this.clickable, e.data, e.data.id);
			if (e.colDef.headerName === 'Statut') {
				this.$emit('statuschange', e);
			} else if (this.clickable && e.data && e.data.id) {
				console.log('I should move');
				this.$router.push({ name: 'ClientsDetails', params: { id: e.data.id } });
			}
		}
	},
	computed: {
		rowDataFiltered: function rowDataFiltered() {
			return this.elements.map(function (client) {
				return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, client, {
					name: client.first_name + ' ' + client.last_name
				});
			});
		}
	}
});

/***/ }),
/* 520 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modals_ClientModal__ = __webpack_require__(356);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modals_ClientModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__modals_ClientModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_components_baseModal__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_components_baseModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__common_components_baseModal__);








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Client',
  components: {
    baseModal: __WEBPACK_IMPORTED_MODULE_5__common_components_baseModal___default.a
  },
  data: function data() {
    return {
      showClientModal: false,
      contentModal: __WEBPACK_IMPORTED_MODULE_4__modals_ClientModal___default.a
    };
  },
  mounted: function mounted() {
    console.log(this.user, this.client);
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].commit('LOADER_IN');
    var promiseClient = __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].dispatch('getClientById', to.params.id);
    var promiseEstate = __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].dispatch('getClientEstateById', to.params.id);
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all([promiseClient, promiseEstate]).then(function () {
      next();
    }).catch(function () {
      next(false);
    }).finally(function () {
      __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].commit('LOADER_OUT');
    });
  },

  methods: {
    goBack: function goBack() {
      this.$router.go(-1);
    },
    updateClientStatus: function updateClientStatus(e) {
      var id = this.user.id;
      var enable = e;
      __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].commit('LOADER_IN');
      if (enable) {
        this.$store.dispatch('enableClient', id).finally(function () {
          __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].commit('LOADER_OUT');
        });
      } else {
        this.$store.dispatch('disableClient', id).finally(function () {
          __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].commit('LOADER_OUT');
        });
      }
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapGetters */])({
    client: 'client',
    estate: 'estate'
  }), {
    user: function user() {
      return this.client.user;
    },
    userModal: function userModal() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.client, { office: this.user.office.name });
    }
  })
});

/***/ }),
/* 521 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modals_ClientModal__ = __webpack_require__(356);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modals_ClientModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__modals_ClientModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_components_baseModal__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_components_baseModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__common_components_baseModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ClientsTable__ = __webpack_require__(618);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ClientsTable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__ClientsTable__);









/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'Clients',
	components: {
		Table: __WEBPACK_IMPORTED_MODULE_5__ClientsTable___default.a,
		baseModal: __WEBPACK_IMPORTED_MODULE_4__common_components_baseModal___default.a
	},
	data: function data() {
		return {
			showAddClient: false,
			contentModal: __WEBPACK_IMPORTED_MODULE_3__modals_ClientModal___default.a
		};
	},
	beforeRouteEnter: function beforeRouteEnter(to, from, next) {
		__WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].commit('LOADER_IN');
		__WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].dispatch('getClients').then(function () {
			next();
		}).catch(function () {
			next(false);
		}).finally(function () {
			__WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].commit('LOADER_OUT');
		});
	},

	methods: {
		updateStatus: function updateStatus(e) {
			var value = e.value,
			    rowIndex = e.rowIndex;

			var id = this.clients[rowIndex].id;
			var enable = !value;
			__WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].commit('LOADER_IN');
			if (enable) {
				this.$store.dispatch('enableClient', id).finally(function () {
					__WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].commit('LOADER_OUT');
				});
			} else {
				this.$store.dispatch('disableClient', id).finally(function () {
					__WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].commit('LOADER_OUT');
				});
			}
		}
	},
	computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])({
		clients: 'clients'
	}))
});

/***/ }),
/* 522 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__fixtures_countries__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vee_validate__ = __webpack_require__(103);







__WEBPACK_IMPORTED_MODULE_3_vee_validate__["a" /* Validator */].extend('alpha_dash_spaces', {
	getMessage: function getMessage(field) {
		return 'Le champ ' + field + ' ne peut contenir que des caractères des tirets et des espaces';
	},
	validate: function validate(value) {
		for (var i = 0; i < value.length; i++) {
			if ('aàbcçdeéèfghijklmnopqrstuvwxyz -'.indexOf(value[i].toLowerCase()) === -1) {
				return false;
			}
		}
		return true;
	}
});


/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'AddClient',
	props: ['data'],
	data: function data() {
		return {
			cabinets: [],
			countries: __WEBPACK_IMPORTED_MODULE_2__fixtures_countries__["a" /* default */],
			isEdit: false,
			user: {
				first_name: "",
				last_name: "",
				phone: "",
				email: "",
				address: "",
				zipcode: "",
				city: "",
				company_siret: null,
				company_name: null,
				country: null,
				office: null,
				birthdate: null
			}
		};
	},
	beforeMount: function beforeMount() {
		var _this = this;

		this.$store.dispatch('getCabinets').then(function () {
			_this.cabinets = _this.$store.getters['cabinets'];
		});

		if (this.data) {
			this.user = this.data.user;
			this.user.company_siret = this.data.company_siret;
			this.user.company_name = this.data.company_name;
		}
	},
	mounted: function mounted() {
		if (this.data) {
			this.isEdit = this.data.id;
		}
	},

	methods: {
		close: function close() {
			this.$emit('close');
		},
		submit: function submit() {
			var _this2 = this;

			var officeId = null;
			if (this.isSuperAdmin) {
				officeId = this.cabinets.find(function (cabinet) {
					return cabinet.name === _this2.user.office;
				}).id;
			} else {
				officeId = this.officeId;
			}

			this.$store.commit('LOADER_IN');

			var userToSend = {
				'first_name': this.user.first_name,
				'last_name': this.user.last_name,
				'email': this.user.email,
				'office_id': officeId,
				'phone': this.user.phone,
				'address': this.user.address,
				'zipcode': this.user.zipcode,
				'city': this.user.city,
				'country': this.user.country,
				'company_name': this.user.company_name,
				'company_siret': this.user.company_siret,
				'birthdate': this.user.birthdate
			};

			if (this.isEdit) {
				userToSend['user_id'] = this.user.id;
			}

			var promise = this.isEdit ? this.$store.dispatch('editClient', userToSend) : this.$store.dispatch('addClient', userToSend);
			promise.then(function () {
				_this2.close();
			}).catch(function () {
				_this2.$notify({
					type: 'error',
					group: 'default',
					title: 'Une erreur est survenue',
					text: ''
				});
			}).finally(function () {
				_this2.$store.commit('LOADER_OUT');
			});
		},
		validateBeforeSubmit: function validateBeforeSubmit() {
			var _this3 = this;

			this.$validator.validateAll().then(function (result) {
				if (result) {
					_this3.submit();
					return;
				}
			});
		}
	},
	computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
		cabinetsNames: function cabinetsNames() {
			return this.cabinets ? this.cabinets.map(function (cabinet) {
				return cabinet.name;
			}) : [];
		}
	}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])({
		isSuperAdmin: 'isSuperAdmin',
		officeId: 'officeId'
	}))
});

/***/ }),
/* 523 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_components_ag_table__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_components_ag_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__common_components_ag_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_constants__ = __webpack_require__(504);





/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'Activity',
	props: ['elements', 'clickable'],
	components: {
		AgTable: __WEBPACK_IMPORTED_MODULE_1__common_components_ag_table___default.a
	},
	data: function data() {
		return {
			columnDefs: null,
			rowData: this.elements,
			tableOptions: {
				pagination: false,
				headerHeight: 30,
				rowHeight: 44
			}
		};
	},
	beforeMount: function beforeMount() {
		this.columnDefs = [{ name: 'Pic-id', field: 'media', cellType: 'roundImg', width: 80, cellClass: 'cell-center' }, { name: 'Nom', field: 'name', width: 150 }, { name: 'Cabinet', field: 'office.name', width: 120 }, { name: 'E-mail', field: 'email', cellType: 'light', width: 200 }, { name: 'Téléphone', field: 'phone', cellType: 'light', width: 120 }, { name: 'Adresse', field: 'address', cellType: 'light', width: 150 }, { name: 'Ville', field: 'city', cellType: 'light', width: 120 }, { name: 'Pays', field: 'country', cellType: 'light', width: 100 }, { name: 'Role', field: 'role', cellType: 'light', width: 120 }, { name: 'Statut', field: 'enabled', cellType: 'statusAvailable', width: 90 }];
	},

	methods: {
		handleCellClick: function handleCellClick(e) {
			if (e.colDef.headerName === 'Statut') {
				this.$emit('statuschange', e);
			} else if (this.clickable && e.data && e.data.id) {
				this.$router.push({ name: 'ConseillersDetails', params: { id: e.data.id } });
			}
		}
	},
	computed: {
		rowDataFiltered: function rowDataFiltered() {
			return this.elements.map(function (conseiller) {
				var role = '';
				var found = __WEBPACK_IMPORTED_MODULE_2__utils_constants__["a" /* ROLES */].find(function (role) {
					return conseiller.roles[0] === role.key;
				});
				if (found) {
					role = found.label;
				}

				return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, conseiller, {
					name: conseiller.first_name + ' ' + conseiller.last_name,
					role: role
				});
			});
		}
	}
});

/***/ }),
/* 524 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_components_ag_table__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_components_ag_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__common_components_ag_table__);




/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'ClientsTable',
	props: ['elements', 'clickable'],
	components: {
		AgTable: __WEBPACK_IMPORTED_MODULE_1__common_components_ag_table___default.a
	},
	data: function data() {
		return {
			columnDefs: null,
			rowData: this.elements,
			tableOptions: {
				pagination: false,
				headerHeight: 30,
				rowHeight: 44
			}
		};
	},
	beforeMount: function beforeMount() {
		this.columnDefs = [{ name: 'Pic-id', field: 'picture', cellType: 'roundImg', width: 80 }, { name: 'Nom', field: 'name', width: 150 }, { name: 'E-mail', field: 'email', cellType: 'light', width: 250 }, { name: 'Téléphone', field: 'phone', cellType: 'light', width: 120 }, { name: 'Adresse', field: 'address', cellType: 'light', width: 150 }, { name: 'Ville', field: 'city', cellType: 'light', width: 120 }, { name: 'Pays', field: 'country', cellType: 'light', width: 100 }, { name: 'Statut', field: 'enabled', cellType: 'statusAvailable', width: 100 }];
	},

	methods: {
		handleCellClick: function handleCellClick(e) {
			if (e.colDef.headerName === 'Statut') {
				this.$emit('statuschange', e);
			} else if (this.clickable && e.data && e.data.id) {
				this.$router.push({ name: 'ClientsDetails', params: { id: e.data.id } });
			}
		}
	},
	computed: {
		rowDataFiltered: function rowDataFiltered() {
			return this.rowData.map(function (client) {
				return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, client, {
					name: client.first_name + ' ' + client.last_name
				});
			});
		}
	}
});

/***/ }),
/* 525 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modals_ConseillerModal__ = __webpack_require__(357);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modals_ConseillerModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__modals_ConseillerModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_components_baseModal__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_components_baseModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__common_components_baseModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ClientsTable__ = __webpack_require__(622);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ClientsTable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__ClientsTable__);








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Conseillers',
  components: {
    Table: __WEBPACK_IMPORTED_MODULE_5__ClientsTable___default.a,
    baseModal: __WEBPACK_IMPORTED_MODULE_4__common_components_baseModal___default.a
  },
  data: function data() {
    return {
      showAddConseiller: false,
      contentModal: __WEBPACK_IMPORTED_MODULE_3__modals_ConseillerModal___default.a
    };
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].commit('LOADER_IN');
    __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].dispatch('getConseillerById', to.params.id).then(function () {
      next();
    }).catch(function () {
      next(false);
    }).finally(function () {
      __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].commit('LOADER_OUT');
    });
  },

  methods: {
    goBack: function goBack() {
      this.$router.push({ name: 'Conseillers' });
    },
    updateConseillerStatus: function updateConseillerStatus(e) {
      console.log(e);
      var enable = e;
      __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].commit('LOADER_IN');
      if (enable) {
        this.$store.dispatch('enableConseiller', this.advisor.id).finally(function () {
          __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].commit('LOADER_OUT');
        });
      } else {
        this.$store.dispatch('disableConseiller', this.advisor.id).finally(function () {
          __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].commit('LOADER_OUT');
        });
      }
    },
    updateClientStatus: function updateClientStatus(e) {
      var value = e.value,
          rowIndex = e.rowIndex;

      var id = this.clients[rowIndex].user.id;
      var enable = !value;
      __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].commit('LOADER_IN');
      if (enable) {
        this.$store.dispatch('enableAdvisorClient', id).finally(function () {
          __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].commit('LOADER_OUT');
        });
      } else {
        this.$store.dispatch('disableAdvisorClient', id).finally(function () {
          __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].commit('LOADER_OUT');
        });
      }
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    displayedClients: function displayedClients() {
      return this.clients.map(function (client) {
        return client.user;
      });
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapState */])({
    advisor: function advisor(state) {
      return state.conseillers.advisor;
    },
    clients: function clients(state) {
      return state.conseillers.clients;
    }
  }))
});

/***/ }),
/* 526 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modals_ConseillerModal__ = __webpack_require__(357);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modals_ConseillerModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__modals_ConseillerModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_components_baseModal__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_components_baseModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__common_components_baseModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ConseillersTable__ = __webpack_require__(621);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ConseillersTable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__ConseillersTable__);









/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'Conseillers',
	components: {
		Table: __WEBPACK_IMPORTED_MODULE_5__ConseillersTable___default.a,
		baseModal: __WEBPACK_IMPORTED_MODULE_4__common_components_baseModal___default.a
	},
	beforeRouteEnter: function beforeRouteEnter(to, from, next) {
		__WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].commit('LOADER_IN');
		__WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].dispatch('getConseillers').then(function () {
			next();
		}).catch(function () {
			next(false);
		}).finally(function () {
			__WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].commit('LOADER_OUT');
		});
	},
	data: function data() {
		return {
			showAddConseiller: false,
			contentModal: __WEBPACK_IMPORTED_MODULE_3__modals_ConseillerModal___default.a
		};
	},

	methods: {
		updateStatus: function updateStatus(e) {
			var value = e.value,
			    rowIndex = e.rowIndex;

			var id = this.conseillers[rowIndex].id;
			var enable = !value;
			__WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].commit('LOADER_IN');
			if (enable) {
				this.$store.dispatch('enableConseiller', id).finally(function () {
					__WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].commit('LOADER_OUT');
				});
			} else {
				this.$store.dispatch('disableConseiller', id).finally(function () {
					__WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].commit('LOADER_OUT');
				});
			}
		}
	},
	computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])({
		conseillers: "conseillers"
	}))
});

/***/ }),
/* 527 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__fixtures_countries__ = __webpack_require__(201);





/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'AddConseiller',
	props: ['data'],
	data: function data() {
		return {
			cabinets: [],
			countries: __WEBPACK_IMPORTED_MODULE_1__fixtures_countries__["a" /* default */],
			user: {
				first_name: "",
				last_name: "",
				password: "",
				phone: "",
				email: "",
				address: "",
				zipcode: "",
				city: "",
				office: null,

				country: null,
				enabled: true,
				role: 'CGP',
				centerOfInterests: []
			}
		};
	},
	beforeMount: function beforeMount() {
		var _this = this;

		this.$store.dispatch('getCabinets').then(function () {
			_this.cabinets = _this.$store.getters['cabinets'];
		});
		if (this.data) {
			this.user = this.data;
		} else {}
	},

	methods: {
		close: function close() {
			this.$emit('close');
		},
		submit: function submit() {
			var _this2 = this;

			var foundCabinet = this.cabinets.find(function (cabinet) {
				return cabinet.name === _this2.user.office;
			});

			this.$store.commit('LOADER_IN');
			this.$store.dispatch('addConseiller', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.user, { office: foundCabinet.id })).then(function () {
				_this2.$store.commit('LOADER_OUT');
				_this2.close();
			}).catch(function () {
				_this2.$store.commit('LOADER_OUT');
				_this2.close();
			});
		},
		validateBeforeSubmit: function validateBeforeSubmit() {
			var _this3 = this;

			this.$validator.validateAll().then(function (result) {
				if (result) {
					_this3.submit();
					return;
				}
			});
		}
	},
	computed: {
		cabinetsNames: function cabinetsNames() {
			return this.cabinets ? this.cabinets.map(function (cabinet) {
				return cabinet.name;
			}) : [];
		}
	}
});

/***/ }),
/* 528 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_api_user__ = __webpack_require__(74);



/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'Login',
	data: function data() {
		return {
			email: '',
			password: '',
			emailReset: '',
			login: true,
			hardLogin: true,
			loginusMaximus: true
		};
	},
	mounted: function mounted() {
		if (this.$route.name === 'ResetPasswordEmailAsk') {
			this.switchViewForth();
		}
	},

	watch: {
		$route: function $route(to, from) {
			if (to.name === 'ResetPasswordEmailAsk') {
				this.switchViewForth();
			} else {
				this.switchViewBack();
			}
		}
	},
	methods: {
		connect: function connect() {
			var _this = this;

			this.$validator.validate().then(function (validate) {
				if (validate) {
					_this.$store.commit('LOADER_IN');
					_this.$store.dispatch('login', {
						email: _this.email,
						password: _this.password
					}).then(function () {
						_this.$router.push({ name: 'Profile' });
					}).catch(function (err) {
						console.log({ err: err });
						_this.$notify({
							type: 'error',
							group: 'default',
							title: 'Problème lors de la connexion',
							text: 'Mauvais login ou mot de passe'
						});
					}).finally(function () {
						_this.$store.commit('LOADER_OUT');
					});
				}
			});
		},
		resetPassword: function resetPassword() {
			var _this2 = this;

			this.$validator.validate().then(function (validate) {
				if (validate) {
					__WEBPACK_IMPORTED_MODULE_0__services_api_user__["a" /* default */].resetPassword(_this2.emailReset).then(function () {
						_this2.$notify({
							type: 'success',
							group: 'default',
							title: 'Mot de passe réinitialisé',
							text: 'Vous allez recevoir un email avec votre nouveau mot de passe'
						});
						_this2.switchViewBack();
					}).catch(function () {
						_this2.$notify({
							type: 'error',
							group: 'default',
							title: 'Une erreur est survenue',
							text: 'Il est possible que cette adresse n\'appartienne à aucun compte'
						});
					});
				}
			});
		},
		switchViewForth: function switchViewForth() {
			var _this3 = this;

			this.login = !this.login;
			window.setTimeout(function () {
				_this3.loginusMaximus = !_this3.loginusMaximus;
			}, 400);
			window.setTimeout(function () {
				_this3.hardLogin = !_this3.hardLogin;
			}, 500);
		},
		switchViewBack: function switchViewBack() {
			var _this4 = this;

			this.hardLogin = !this.hardLogin;
			window.setTimeout(function () {
				_this4.loginusMaximus = !_this4.loginusMaximus;
			}, 400);
			window.setTimeout(function () {
				_this4.login = !_this4.login;
			}, 500);
		}
	}
});

/***/ }),
/* 529 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_header_vue__ = __webpack_require__(612);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_header_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_header_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_notification_panel__ = __webpack_require__(614);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_notification_panel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_notification_panel__);





/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'Hello',
	components: {
		myHeader: __WEBPACK_IMPORTED_MODULE_0__components_header_vue___default.a,
		NotificationPanel: __WEBPACK_IMPORTED_MODULE_1__components_notification_panel___default.a
	},
	data: function data() {
		return {
			notifPanelActive: false
		};
	}
});

/***/ }),
/* 530 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(534);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_components_Form_RadioBox__ = __webpack_require__(610);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_components_Form_RadioBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__common_components_Form_RadioBox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_modal_ChangePassword__ = __webpack_require__(613);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_modal_ChangePassword___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_modal_ChangePassword__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vee_validate__ = __webpack_require__(103);









__WEBPACK_IMPORTED_MODULE_5_vee_validate__["a" /* Validator */].extend('alpha_dash_spaces', {
  getMessage: function getMessage(field) {
    return 'Le champ ' + field + ' ne peut contenir que des caractères des tirets et des espaces';
  },
  validate: function validate(value) {
    for (var i = 0; i < value.length; i++) {
      if ('aàbcçdeéèfghijklmnopqrstuvwxyz -'.indexOf(value[i].toLowerCase()) === -1) {
        return false;
      }
    }
    return true;
  }
});

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Profile',
  components: {
    RadioBox: __WEBPACK_IMPORTED_MODULE_2__common_components_Form_RadioBox___default.a
  },
  data: function data() {
    return {
      userM: {
        email: null,
        firstname: null,
        lastname: null,
        address: {
          line: null,
          zip: null,
          city: null,
          country: null
        },
        phone: null,
        picture: null,
        password: null
      },
      isAvailable: false,
      displayChangePassword: false,
      contentModalPassword: __WEBPACK_IMPORTED_MODULE_3__components_modal_ChangePassword___default.a,
      mailNotif: false,
      acceptCGU: false,
      acceptDER: false,
      error: {
        cgu: false,
        der: false
      }
    };
  },
  mounted: function mounted() {
    this.userM = {
      email: this.user.email,
      firstname: this.user.firstname,
      lastname: this.user.lastname,
      address: {
        line: this.user.address.line,
        zip: this.user.address.zip,
        city: this.user.address.city,
        country: this.user.address.country
      },
      phone: this.user.phone,
      picture: this.user.picture,
      password: null,
      newPassword1: null,
      newPassword2: null
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapGetters */])({
    user: 'user'
  })),
  methods: {
    uploadNewPicture: function uploadNewPicture(value) {
      var _this = this;

      var preview = document.getElementById('userPicture');
      var file = value.path[0].files[0];
      var reader = new FileReader();

      reader.addEventListener('load', function () {
        preview.src = reader.result;
        _this.$store.dispatch('updateProfilePicture', reader.result);
      });

      if (file) {
        reader.readAsDataURL(file);
      }
    },
    procNewPicture: function procNewPicture() {
      document.getElementById('newPicture').click();
    },
    saveProfile: function saveProfile() {
      var _this2 = this;

      this.$validator.validate().then(function (result) {
        if (result) {
          _this2.$store.dispatch('saveProfile', _this2.userM).then(function () {
            _this2.$notify({
              type: 'success',
              group: 'default',
              title: 'Félicitations',
              text: 'Les modifications ont été apporté à votre profile'
            });
          }).catch(function (error) {
            var message = '';
            if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(error.response.data.errors).indexOf('email') !== -1) message = 'Cette adresse email est déjà utilisé';
            _this2.$notify({
              type: 'error',
              group: 'default',
              title: 'Une erreur est survenue',
              text: message
            });
          });
        }
      });
    },
    setAvailable: function setAvailable(val) {
      this.isAvailable = val;
      this.showUnavailable = !val;
    },
    logout: function logout() {
      var _this3 = this;

      this.$store.dispatch('logout').finally(function () {
        _this3.$router.push({ name: 'Login' });
      });
    }
  }
});

/***/ }),
/* 531 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_services_Emma__ = __webpack_require__(200);



/* harmony default export */ __webpack_exports__["default"] = ({
	data: function data() {
		return {
			password: null,
			passwordConfirm: null,
			token: null,
			errorsame: null,
			isValidToken: true
		};
	},
	mounted: function mounted() {
		this.token = this.$route.params.token;
		this.checkValidToken();
	},

	methods: {
		checkValidToken: function checkValidToken() {
			var _this = this;

			this.$store.commit('LOADER_IN');
			__WEBPACK_IMPORTED_MODULE_0__common_services_Emma__["a" /* default */].get('api/resetting/check/' + this.token).then(function (result) {
				_this.$store.commit('LOADER_OUT');
				_this.isValidToken = result.data.success;
			}).catch(function () {
				_this.$store.commit('LOADER_OUT');
				_this.isValidToken = false;
			});
		},
		send: function send() {
			var _this2 = this;

			if (this.password === this.passwordConfirm && this.password !== '') {
				var data = new FormData();
				data.append('plain_password[first]', this.password);
				data.append('plain_password[second]', this.passwordConfirm);
				__WEBPACK_IMPORTED_MODULE_0__common_services_Emma__["a" /* default */].post('api/resetting/reset/' + this.token, data).then(function (result) {
					if (result.data.success) {
						_this2.$notify({
							type: 'success',
							group: 'default',
							title: 'Le mot de passe a été correctement réinitialisé',
							text: 'Vous pouvez vous connecter avec votre nouveau mot de passe'
						});
						_this2.$router.push({ name: 'Login' });
					} else {
						_this2.$notify({
							type: 'error',
							group: 'default',
							title: 'Le mot de passe n\'a pas pu être réinitialisé',
							text: 'Le token a expiré'
						});
					}
				}).catch(function (error) {
					console.warn(error);
					_this2.$notify({
						type: 'error',
						group: 'default',
						title: 'Une erreur est survenue',
						text: 'Veuillez réessayer'
					});
				});
			} else {
				this.errorsame = true;
			}
		}
	}
});

/***/ }),
/* 532 */,
/* 533 */,
/* 534 */,
/* 535 */,
/* 536 */,
/* 537 */,
/* 538 */,
/* 539 */,
/* 540 */,
/* 541 */,
/* 542 */,
/* 543 */,
/* 544 */,
/* 545 */,
/* 546 */,
/* 547 */,
/* 548 */,
/* 549 */,
/* 550 */,
/* 551 */,
/* 552 */,
/* 553 */,
/* 554 */,
/* 555 */,
/* 556 */,
/* 557 */,
/* 558 */,
/* 559 */,
/* 560 */,
/* 561 */,
/* 562 */,
/* 563 */,
/* 564 */,
/* 565 */,
/* 566 */,
/* 567 */,
/* 568 */,
/* 569 */,
/* 570 */,
/* 571 */,
/* 572 */,
/* 573 */,
/* 574 */,
/* 575 */,
/* 576 */,
/* 577 */,
/* 578 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 579 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 580 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 581 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 582 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 583 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 584 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 585 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 586 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 587 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 588 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 589 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 590 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 591 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 592 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 593 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 594 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 595 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 596 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 597 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 598 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 599 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 600 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 601 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 602 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 603 */,
/* 604 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 229,
	"./af.js": 229,
	"./ar": 236,
	"./ar-dz": 230,
	"./ar-dz.js": 230,
	"./ar-kw": 231,
	"./ar-kw.js": 231,
	"./ar-ly": 232,
	"./ar-ly.js": 232,
	"./ar-ma": 233,
	"./ar-ma.js": 233,
	"./ar-sa": 234,
	"./ar-sa.js": 234,
	"./ar-tn": 235,
	"./ar-tn.js": 235,
	"./ar.js": 236,
	"./az": 237,
	"./az.js": 237,
	"./be": 238,
	"./be.js": 238,
	"./bg": 239,
	"./bg.js": 239,
	"./bm": 240,
	"./bm.js": 240,
	"./bn": 241,
	"./bn.js": 241,
	"./bo": 242,
	"./bo.js": 242,
	"./br": 243,
	"./br.js": 243,
	"./bs": 244,
	"./bs.js": 244,
	"./ca": 245,
	"./ca.js": 245,
	"./cs": 246,
	"./cs.js": 246,
	"./cv": 247,
	"./cv.js": 247,
	"./cy": 248,
	"./cy.js": 248,
	"./da": 249,
	"./da.js": 249,
	"./de": 252,
	"./de-at": 250,
	"./de-at.js": 250,
	"./de-ch": 251,
	"./de-ch.js": 251,
	"./de.js": 252,
	"./dv": 253,
	"./dv.js": 253,
	"./el": 254,
	"./el.js": 254,
	"./en-SG": 255,
	"./en-SG.js": 255,
	"./en-au": 256,
	"./en-au.js": 256,
	"./en-ca": 257,
	"./en-ca.js": 257,
	"./en-gb": 258,
	"./en-gb.js": 258,
	"./en-ie": 259,
	"./en-ie.js": 259,
	"./en-il": 260,
	"./en-il.js": 260,
	"./en-nz": 261,
	"./en-nz.js": 261,
	"./eo": 262,
	"./eo.js": 262,
	"./es": 265,
	"./es-do": 263,
	"./es-do.js": 263,
	"./es-us": 264,
	"./es-us.js": 264,
	"./es.js": 265,
	"./et": 266,
	"./et.js": 266,
	"./eu": 267,
	"./eu.js": 267,
	"./fa": 268,
	"./fa.js": 268,
	"./fi": 269,
	"./fi.js": 269,
	"./fo": 270,
	"./fo.js": 270,
	"./fr": 102,
	"./fr-ca": 271,
	"./fr-ca.js": 271,
	"./fr-ch": 272,
	"./fr-ch.js": 272,
	"./fr.js": 102,
	"./fy": 273,
	"./fy.js": 273,
	"./ga": 274,
	"./ga.js": 274,
	"./gd": 275,
	"./gd.js": 275,
	"./gl": 276,
	"./gl.js": 276,
	"./gom-latn": 277,
	"./gom-latn.js": 277,
	"./gu": 278,
	"./gu.js": 278,
	"./he": 279,
	"./he.js": 279,
	"./hi": 280,
	"./hi.js": 280,
	"./hr": 281,
	"./hr.js": 281,
	"./hu": 282,
	"./hu.js": 282,
	"./hy-am": 283,
	"./hy-am.js": 283,
	"./id": 284,
	"./id.js": 284,
	"./is": 285,
	"./is.js": 285,
	"./it": 287,
	"./it-ch": 286,
	"./it-ch.js": 286,
	"./it.js": 287,
	"./ja": 288,
	"./ja.js": 288,
	"./jv": 289,
	"./jv.js": 289,
	"./ka": 290,
	"./ka.js": 290,
	"./kk": 291,
	"./kk.js": 291,
	"./km": 292,
	"./km.js": 292,
	"./kn": 293,
	"./kn.js": 293,
	"./ko": 294,
	"./ko.js": 294,
	"./ku": 295,
	"./ku.js": 295,
	"./ky": 296,
	"./ky.js": 296,
	"./lb": 297,
	"./lb.js": 297,
	"./lo": 298,
	"./lo.js": 298,
	"./lt": 299,
	"./lt.js": 299,
	"./lv": 300,
	"./lv.js": 300,
	"./me": 301,
	"./me.js": 301,
	"./mi": 302,
	"./mi.js": 302,
	"./mk": 303,
	"./mk.js": 303,
	"./ml": 304,
	"./ml.js": 304,
	"./mn": 305,
	"./mn.js": 305,
	"./mr": 306,
	"./mr.js": 306,
	"./ms": 308,
	"./ms-my": 307,
	"./ms-my.js": 307,
	"./ms.js": 308,
	"./mt": 309,
	"./mt.js": 309,
	"./my": 310,
	"./my.js": 310,
	"./nb": 311,
	"./nb.js": 311,
	"./ne": 312,
	"./ne.js": 312,
	"./nl": 314,
	"./nl-be": 313,
	"./nl-be.js": 313,
	"./nl.js": 314,
	"./nn": 315,
	"./nn.js": 315,
	"./pa-in": 316,
	"./pa-in.js": 316,
	"./pl": 317,
	"./pl.js": 317,
	"./pt": 319,
	"./pt-br": 318,
	"./pt-br.js": 318,
	"./pt.js": 319,
	"./ro": 320,
	"./ro.js": 320,
	"./ru": 321,
	"./ru.js": 321,
	"./sd": 322,
	"./sd.js": 322,
	"./se": 323,
	"./se.js": 323,
	"./si": 324,
	"./si.js": 324,
	"./sk": 325,
	"./sk.js": 325,
	"./sl": 326,
	"./sl.js": 326,
	"./sq": 327,
	"./sq.js": 327,
	"./sr": 329,
	"./sr-cyrl": 328,
	"./sr-cyrl.js": 328,
	"./sr.js": 329,
	"./ss": 330,
	"./ss.js": 330,
	"./sv": 331,
	"./sv.js": 331,
	"./sw": 332,
	"./sw.js": 332,
	"./ta": 333,
	"./ta.js": 333,
	"./te": 334,
	"./te.js": 334,
	"./tet": 335,
	"./tet.js": 335,
	"./tg": 336,
	"./tg.js": 336,
	"./th": 337,
	"./th.js": 337,
	"./tl-ph": 338,
	"./tl-ph.js": 338,
	"./tlh": 339,
	"./tlh.js": 339,
	"./tr": 340,
	"./tr.js": 340,
	"./tzl": 341,
	"./tzl.js": 341,
	"./tzm": 343,
	"./tzm-latn": 342,
	"./tzm-latn.js": 342,
	"./tzm.js": 343,
	"./ug-cn": 344,
	"./ug-cn.js": 344,
	"./uk": 345,
	"./uk.js": 345,
	"./ur": 346,
	"./ur.js": 346,
	"./uz": 348,
	"./uz-latn": 347,
	"./uz-latn.js": 347,
	"./uz.js": 348,
	"./vi": 349,
	"./vi.js": 349,
	"./x-pseudo": 350,
	"./x-pseudo.js": 350,
	"./yo": 351,
	"./yo.js": 351,
	"./zh-cn": 352,
	"./zh-cn.js": 352,
	"./zh-hk": 353,
	"./zh-hk.js": 353,
	"./zh-tw": 354,
	"./zh-tw.js": 354
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 604;

/***/ }),
/* 605 */,
/* 606 */,
/* 607 */,
/* 608 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PCEtLSBCeSBTYW0gSGVyYmVydCAoQHNoZXJiKSwgZm9yIGV2ZXJ5b25lLiBNb3JlIEAgaHR0cDovL2dvby5nbC83QUp6YkwgLS0+Cjxzdmcgd2lkdGg9IjQ0IiBoZWlnaHQ9IjQ0IiB2aWV3Qm94PSIwIDAgNDQgNDQiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgc3Ryb2tlPSIjZmY0MDUyIj4KICAgIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCIgc3Ryb2tlLXdpZHRoPSIyIj4KICAgICAgICA8Y2lyY2xlIGN4PSIyMiIgY3k9IjIyIiByPSIxIj4KICAgICAgICAgICAgPGFuaW1hdGUgYXR0cmlidXRlTmFtZT0iciIKICAgICAgICAgICAgICAgIGJlZ2luPSIwcyIgZHVyPSIxLjhzIgogICAgICAgICAgICAgICAgdmFsdWVzPSIxOyAyMCIKICAgICAgICAgICAgICAgIGNhbGNNb2RlPSJzcGxpbmUiCiAgICAgICAgICAgICAgICBrZXlUaW1lcz0iMDsgMSIKICAgICAgICAgICAgICAgIGtleVNwbGluZXM9IjAuMTY1LCAwLjg0LCAwLjQ0LCAxIgogICAgICAgICAgICAgICAgcmVwZWF0Q291bnQ9ImluZGVmaW5pdGUiIC8+CiAgICAgICAgICAgIDxhbmltYXRlIGF0dHJpYnV0ZU5hbWU9InN0cm9rZS1vcGFjaXR5IgogICAgICAgICAgICAgICAgYmVnaW49IjBzIiBkdXI9IjEuOHMiCiAgICAgICAgICAgICAgICB2YWx1ZXM9IjE7IDAiCiAgICAgICAgICAgICAgICBjYWxjTW9kZT0ic3BsaW5lIgogICAgICAgICAgICAgICAga2V5VGltZXM9IjA7IDEiCiAgICAgICAgICAgICAgICBrZXlTcGxpbmVzPSIwLjMsIDAuNjEsIDAuMzU1LCAxIgogICAgICAgICAgICAgICAgcmVwZWF0Q291bnQ9ImluZGVmaW5pdGUiIC8+CiAgICAgICAgPC9jaXJjbGU+CiAgICAgICAgPGNpcmNsZSBjeD0iMjIiIGN5PSIyMiIgcj0iMSI+CiAgICAgICAgICAgIDxhbmltYXRlIGF0dHJpYnV0ZU5hbWU9InIiCiAgICAgICAgICAgICAgICBiZWdpbj0iLTAuOXMiIGR1cj0iMS44cyIKICAgICAgICAgICAgICAgIHZhbHVlcz0iMTsgMjAiCiAgICAgICAgICAgICAgICBjYWxjTW9kZT0ic3BsaW5lIgogICAgICAgICAgICAgICAga2V5VGltZXM9IjA7IDEiCiAgICAgICAgICAgICAgICBrZXlTcGxpbmVzPSIwLjE2NSwgMC44NCwgMC40NCwgMSIKICAgICAgICAgICAgICAgIHJlcGVhdENvdW50PSJpbmRlZmluaXRlIiAvPgogICAgICAgICAgICA8YW5pbWF0ZSBhdHRyaWJ1dGVOYW1lPSJzdHJva2Utb3BhY2l0eSIKICAgICAgICAgICAgICAgIGJlZ2luPSItMC45cyIgZHVyPSIxLjhzIgogICAgICAgICAgICAgICAgdmFsdWVzPSIxOyAwIgogICAgICAgICAgICAgICAgY2FsY01vZGU9InNwbGluZSIKICAgICAgICAgICAgICAgIGtleVRpbWVzPSIwOyAxIgogICAgICAgICAgICAgICAga2V5U3BsaW5lcz0iMC4zLCAwLjYxLCAwLjM1NSwgMSIKICAgICAgICAgICAgICAgIHJlcGVhdENvdW50PSJpbmRlZmluaXRlIiAvPgogICAgICAgIDwvY2lyY2xlPgogICAgPC9nPgo8L3N2Zz4K"

/***/ }),
/* 609 */,
/* 610 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(580)

var Component = __webpack_require__(12)(
  /* script */
  __webpack_require__(507),
  /* template */
  __webpack_require__(631),
  /* scopeId */
  "data-v-0a942600",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 611 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(601)

var Component = __webpack_require__(12)(
  /* script */
  __webpack_require__(510),
  /* template */
  __webpack_require__(654),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 612 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(585)

var Component = __webpack_require__(12)(
  /* script */
  __webpack_require__(513),
  /* template */
  __webpack_require__(637),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 613 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(602)

var Component = __webpack_require__(12)(
  /* script */
  __webpack_require__(514),
  /* template */
  __webpack_require__(655),
  /* scopeId */
  "data-v-ebda1740",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 614 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(600)

var Component = __webpack_require__(12)(
  /* script */
  __webpack_require__(515),
  /* template */
  __webpack_require__(653),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 615 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(592)

var Component = __webpack_require__(12)(
  /* script */
  __webpack_require__(516),
  /* template */
  __webpack_require__(645),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 616 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(581)

var Component = __webpack_require__(12)(
  /* script */
  __webpack_require__(517),
  /* template */
  __webpack_require__(632),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 617 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(578)

var Component = __webpack_require__(12)(
  /* script */
  __webpack_require__(518),
  /* template */
  __webpack_require__(629),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 618 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(593)

var Component = __webpack_require__(12)(
  /* script */
  __webpack_require__(519),
  /* template */
  __webpack_require__(646),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 619 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(584)

var Component = __webpack_require__(12)(
  /* script */
  __webpack_require__(520),
  /* template */
  __webpack_require__(635),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 620 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(587)

var Component = __webpack_require__(12)(
  /* script */
  __webpack_require__(521),
  /* template */
  __webpack_require__(640),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 621 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(586)

var Component = __webpack_require__(12)(
  /* script */
  __webpack_require__(523),
  /* template */
  __webpack_require__(638),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 622 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(599)

var Component = __webpack_require__(12)(
  /* script */
  __webpack_require__(524),
  /* template */
  __webpack_require__(652),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 623 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(591)

var Component = __webpack_require__(12)(
  /* script */
  __webpack_require__(525),
  /* template */
  __webpack_require__(644),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 624 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(594)

var Component = __webpack_require__(12)(
  /* script */
  __webpack_require__(526),
  /* template */
  __webpack_require__(647),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 625 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(582)

var Component = __webpack_require__(12)(
  /* script */
  __webpack_require__(528),
  /* template */
  __webpack_require__(633),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 626 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(597)

var Component = __webpack_require__(12)(
  /* script */
  __webpack_require__(529),
  /* template */
  __webpack_require__(650),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 627 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(12)(
  /* script */
  __webpack_require__(530),
  /* template */
  __webpack_require__(639),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 628 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(583)

var Component = __webpack_require__(12)(
  /* script */
  __webpack_require__(531),
  /* template */
  __webpack_require__(634),
  /* scopeId */
  "data-v-1ee2c163",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 629 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "themeColorContainer",
    staticClass: "inner-modal theme-color-container"
  }, [_c('div', {
    ref: "themeColorPickerContainer",
    staticClass: "theme-color-picker-container",
    style: ('left:' + this.colorPickerPosition.x + 'px;top:' +
      this.colorPickerPosition.y + 'px')
  }, [(_vm.currentThemeColorSelected) ? _c('chrome-color-picker', {
    directives: [{
      name: "click-outside",
      rawName: "v-click-outside",
      value: (_vm.onClickOutside),
      expression: "onClickOutside"
    }],
    model: {
      value: (_vm.colors),
      callback: function($$v) {
        _vm.colors = $$v
      },
      expression: "colors"
    }
  }) : _vm._e()], 1), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "body-modal"
  }, [_c('form', {
    staticClass: "form-ui column default-form-ui"
  }, [_c('div', {
    directives: [{
      name: "inputUI",
      rawName: "v-inputUI"
    }],
    staticClass: "ctn-input ctn-label",
    class: {
      error: _vm.errors.has('cabinetId')
    }
  }, [_c('label', {
    attrs: {
      "for": "name"
    }
  }, [_vm._v("Nom du cabinet")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cabinet.name),
      expression: "cabinet.name"
    }],
    attrs: {
      "type": "text",
      "name": "name"
    },
    domProps: {
      "value": (_vm.cabinet.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.cabinet, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    directives: [{
      name: "inputUI",
      rawName: "v-inputUI"
    }],
    staticClass: "ctn-input ctn-label",
    class: {
      error: _vm.errors.has('cabinetId')
    }
  }, [_c('input', {
    attrs: {
      "type": "file",
      "name": "logo",
      "accept": ".png,.jpg,.jpeg,.svg"
    },
    on: {
      "change": _vm.getFile
    }
  }), _vm._v(" "), (_vm.logoUrl) ? _c('img', {
    attrs: {
      "src": _vm.logoUrl,
      "height": "50px"
    }
  }) : _vm._e()]), _vm._v(" "), (_vm.errors.has('name')) ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.errors.first('name')))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "ctn-duo-input row"
  }, [_c('div', {
    staticClass: "left inner-duo"
  }, [_c('div', {
    directives: [{
      name: "inputUI",
      rawName: "v-inputUI"
    }],
    staticClass: "ctn-input ctn-label",
    class: {
      error: _vm.errors.has('email')
    }
  }, [_c('label', {
    attrs: {
      "for": "email"
    }
  }, [_vm._v("Email")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cabinet.email),
      expression: "cabinet.email"
    }],
    attrs: {
      "type": "text",
      "name": "email"
    },
    domProps: {
      "value": (_vm.cabinet.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.cabinet, "email", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.errors.has('email')) ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.errors.first('email')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "right inner-duo"
  }, [_c('div', {
    directives: [{
      name: "inputUI",
      rawName: "v-inputUI"
    }],
    staticClass: "ctn-input ctn-label",
    class: {
      error: _vm.errors.has('wordpressSite')
    }
  }, [_c('label', {
    attrs: {
      "for": "wordpressSite"
    }
  }, [_vm._v("Lien blog")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cabinet.wordpressSite),
      expression: "cabinet.wordpressSite"
    }],
    attrs: {
      "type": "text",
      "name": "wordpressSite"
    },
    domProps: {
      "value": (_vm.cabinet.wordpressSite)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.cabinet, "wordpressSite", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.errors.has('wordpressSite')) ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.errors.first('wordpressSite')))]) : _vm._e()])]), _vm._v(" "), _c('hr'), _vm._v(" "), (_vm.domains.length < 4) ? _c('div', {
    staticClass: "add-domains",
    on: {
      "click": _vm.addDomain
    }
  }, [_vm._m(2)]) : _vm._e(), _vm._v(" "), _vm._l((_vm.domains), function(domainInfo, index) {
    return [_c('domain-selector', {
      attrs: {
        "domain-info": domainInfo,
        "index": index,
        "domain-types": _vm.domainTypes
      },
      on: {
        "deleteDomain": _vm.deleteDomainAt,
        "domainUpdated": _vm.updateDomain
      }
    })]
  }), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "ctn-duo-input row"
  }, [_c('div', {
    staticClass: "left inner-duo"
  }, [_c('div', {
    staticClass: "color-dropdown",
    on: {
      "click": function($event) {
        _vm.toggleColorPicker($event, 'primary')
      }
    }
  }, [_c('div', {
    staticClass: "color-toggle-container"
  }, [_c('div', {
    staticClass: "color-toggle",
    style: ('background-color:' + _vm.theme.colors.primary)
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-left": "5px"
    }
  }, [_vm._v("Couleur primaire")]), _vm._v(" "), _vm._m(3)])])]), _vm._v(" "), _c('div', {
    staticClass: "right inner-duo"
  }, [_c('div', {
    staticClass: "color-dropdown",
    on: {
      "click": function($event) {
        _vm.toggleColorPicker($event, 'secondary')
      }
    }
  }, [_c('div', {
    staticClass: "color-toggle-container"
  }, [_c('div', {
    staticClass: "color-toggle",
    style: ('background-color:' + _vm.theme.colors.secondary)
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-left": "5px"
    }
  }, [_vm._v("Couleur secondaire")]), _vm._v(" "), _vm._m(4)])])])]), _vm._v(" "), _c('div', {
    staticClass: "ctn-cta right row"
  }, [_c('div', {
    staticClass: "btn btn-gold",
    on: {
      "click": _vm.close
    }
  }, [_vm._v("Annuler")]), _vm._v(" "), _c('div', {
    staticClass: "btn btn-red",
    on: {
      "click": _vm.validateBeforeSubmit
    }
  }, [_vm._v("Enregistrer")])])], 2)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "head-modal spaced-row"
  }, [_c('div', [_c('div', {
    staticClass: "head-modal-title"
  }, [_vm._v("\n\t\t\t\t\tAjouter/Editer un cabinet\n\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "head-modal-emphase"
  }, [_vm._v("\n\t\t\t\t\tModifiez les informations d’un cabinet ou ajoutez en un.\n\t\t\t\t")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ctn-input logo-label"
  }, [_c('label', {
    attrs: {
      "for": "logo"
    }
  }, [_vm._v("Logo")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "add-domains-items"
  }, [_c('p', {
    staticClass: "add-domains-label"
  }, [_vm._v("ajouter un domaine")]), _vm._v(" "), _c('span', {
    staticClass: "icon-form-plus"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "toggle-dropdown"
  }, [_c('i', {
    staticClass: "fas fa-angle-down"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "toggle-dropdown"
  }, [_c('i', {
    staticClass: "fas fa-angle-down"
  })])
}]}

/***/ }),
/* 630 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "inner-modal"
  }, [_c('div', {
    staticClass: "head-modal spaced-row"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "head-modal-label"
  }, [_vm._v("ACTIVATION")]), _vm._v(" "), _c('toggle-input', {
    attrs: {
      "value": _vm.user.enabled
    },
    on: {
      "change": function($event) {
        _vm.user.enabled = !_vm.user.enabled
      }
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "body-modal"
  }, [_c('form', {
    staticClass: "form-ui column default-form-ui"
  }, [_c('div', {
    staticClass: "ctn-duo-input row"
  }, [_c('div', {
    staticClass: "left inner-duo"
  }, [_c('div', {
    directives: [{
      name: "inputUI",
      rawName: "v-inputUI"
    }],
    staticClass: "ctn-input ctn-label",
    class: {
      error: _vm.errors.has('first_name')
    }
  }, [_c('label', {
    attrs: {
      "for": "first_name"
    }
  }, [_vm._v("Prénom")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|alpha_spaces'),
      expression: "'required|alpha_spaces'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.user.first_name),
      expression: "user.first_name"
    }],
    attrs: {
      "type": "text",
      "name": "first_name"
    },
    domProps: {
      "value": (_vm.user.first_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "first_name", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.errors.has('first_name')) ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.errors.first('first_name')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "right inner-duo"
  }, [_c('div', {
    directives: [{
      name: "inputUI",
      rawName: "v-inputUI"
    }],
    staticClass: "ctn-input ctn-label",
    class: {
      error: _vm.errors.has('last_name')
    }
  }, [_c('label', {
    attrs: {
      "for": "last_name"
    }
  }, [_vm._v("Nom")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|alpha_spaces'),
      expression: "'required|alpha_spaces'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.user.last_name),
      expression: "user.last_name"
    }],
    attrs: {
      "type": "text",
      "name": "last_name"
    },
    domProps: {
      "value": (_vm.user.last_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "last_name", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.errors.has('last_name')) ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.errors.first('last_name')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "selectUI",
      rawName: "v-selectUI"
    }],
    staticClass: "ctn-input form-elem-container ctn-select ctn-label",
    class: {
      error: _vm.errors.has('office')
    }
  }, [_c('label', {
    attrs: {
      "for": "select"
    }
  }, [_vm._v("Mon cabinet")]), _vm._v(" "), _c('custom-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "items": _vm.cabinetsNames,
      "data-vv-value-path": "mutableValue",
      "data-vv-name": "office",
      "has-error": _vm.errors.has('office')
    },
    model: {
      value: (_vm.user.office),
      callback: function($$v) {
        _vm.$set(_vm.user, "office", $$v)
      },
      expression: "user.office"
    }
  })], 1), _vm._v(" "), (_vm.errors.has('office')) ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.errors.first('office')))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "ctn-duo-input row"
  }, [_c('div', {
    staticClass: "left inner-duo"
  }, [_c('div', {
    directives: [{
      name: "inputUI",
      rawName: "v-inputUI"
    }],
    staticClass: "ctn-input ctn-label",
    class: {
      error: _vm.errors.has('address')
    }
  }, [_c('label', {
    attrs: {
      "for": "address"
    }
  }, [_vm._v("Adresse du conseiller")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.user.address),
      expression: "user.address"
    }],
    attrs: {
      "type": "text",
      "name": "address"
    },
    domProps: {
      "value": (_vm.user.address)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "address", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.errors.has('address')) ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.errors.first('address')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "right inner-duo"
  }, [_c('div', {
    directives: [{
      name: "inputUI",
      rawName: "v-inputUI"
    }],
    staticClass: "ctn-input ctn-label",
    class: {
      error: _vm.errors.has('zipcode')
    }
  }, [_c('label', {
    attrs: {
      "for": "postalcode"
    }
  }, [_vm._v("Code postal")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|length:5'),
      expression: "'required|length:5'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.user.zipcode),
      expression: "user.zipcode"
    }],
    attrs: {
      "type": "text",
      "name": "zipcode"
    },
    domProps: {
      "value": (_vm.user.zipcode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "zipcode", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.errors.has('zipcode')) ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.errors.first('zipcode')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "ctn-duo-input row"
  }, [_c('div', {
    staticClass: "left inner-duo"
  }, [_c('div', {
    directives: [{
      name: "inputUI",
      rawName: "v-inputUI"
    }],
    staticClass: "ctn-input ctn-label",
    class: {
      error: _vm.errors.has('city')
    }
  }, [_c('label', {
    attrs: {
      "for": "city"
    }
  }, [_vm._v("Ville")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|alpha_spaces'),
      expression: "'required|alpha_spaces'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.user.city),
      expression: "user.city"
    }],
    attrs: {
      "type": "text",
      "name": "city"
    },
    domProps: {
      "value": (_vm.user.city)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "city", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.errors.has('city')) ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.errors.first('city')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "right inner-duo"
  }, [_c('div', {
    directives: [{
      name: "selectUI",
      rawName: "v-selectUI"
    }],
    staticClass: "ctn-input form-elem-container ctn-select ctn-label",
    class: {
      error: _vm.errors.has('country')
    }
  }, [_c('label', {
    attrs: {
      "for": "select"
    }
  }, [_vm._v("Pays")]), _vm._v(" "), _c('custom-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "items": _vm.countries,
      "data-vv-value-path": "mutableValue",
      "data-vv-name": "country",
      "has-error": _vm.errors.has('country')
    },
    model: {
      value: (_vm.user.country),
      callback: function($$v) {
        _vm.$set(_vm.user, "country", $$v)
      },
      expression: "user.country"
    }
  })], 1), _vm._v(" "), (_vm.errors.has('country')) ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.errors.first('country')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "ctn-duo-input row"
  }, [_c('div', {
    staticClass: "left inner-duo"
  }, [_c('div', {
    directives: [{
      name: "inputUI",
      rawName: "v-inputUI"
    }],
    staticClass: "ctn-input ctn-label",
    class: {
      error: _vm.errors.has('phone')
    }
  }, [_c('label', {
    attrs: {
      "for": "phone"
    }
  }, [_vm._v("Téléphone")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|numeric|length:10'),
      expression: "'required|numeric|length:10'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.user.phone),
      expression: "user.phone"
    }],
    attrs: {
      "type": "phone",
      "name": "phone"
    },
    domProps: {
      "value": (_vm.user.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "phone", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.errors.has('phone')) ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.errors.first('phone')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "right inner-duo"
  }, [_c('div', {
    directives: [{
      name: "inputUI",
      rawName: "v-inputUI"
    }],
    staticClass: "ctn-input ctn-label",
    class: {
      error: _vm.errors.has('email')
    }
  }, [_c('label', {
    attrs: {
      "for": "email"
    }
  }, [_vm._v("Adresse mail")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|email'),
      expression: "'required|email'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.user.email),
      expression: "user.email"
    }],
    attrs: {
      "type": "email",
      "name": "email"
    },
    domProps: {
      "value": (_vm.user.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "email", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.errors.has('email')) ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.errors.first('email')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "inputUI",
      rawName: "v-inputUI"
    }],
    staticClass: "ctn-input ctn-label",
    class: {
      error: _vm.errors.has('password')
    }
  }, [_c('label', {
    attrs: {
      "for": "password"
    }
  }, [_vm._v("Mot de passe")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.password),
      expression: "user.password"
    }],
    attrs: {
      "type": "password",
      "name": "password"
    },
    domProps: {
      "value": (_vm.user.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "password", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.errors.has('password')) ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.errors.first('password')))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "ctn-cta right row"
  }, [_c('div', {
    staticClass: "btn btn-gold",
    on: {
      "click": _vm.close
    }
  }, [_vm._v("Annuler")]), _vm._v(" "), _c('div', {
    staticClass: "btn btn-red",
    on: {
      "click": _vm.validateBeforeSubmit
    }
  }, [_vm._v("Enregistrer")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "head-modal-title"
  }, [_vm._v("\n\t\t\t\t\tAjouter/Editer un conseiller\n\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "head-modal-emphase"
  }, [_vm._v("\n\t\t\t\t\tModifiez les informations d’un conseiller ou ajoutez en un.\n\t\t\t\t")])])
}]}

/***/ }),
/* 631 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "radio-box",
    on: {
      "click": _vm.change
    }
  }, [_c('div', {
    staticClass: "content",
    class: {
      active: _vm.val
    }
  })])
},staticRenderFns: []}

/***/ }),
/* 632 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sub-main column"
  }, [_c('div', {
    staticClass: "sub-page column"
  }, [_c('section', {
    staticClass: "take-place column activity-container container-background"
  }, [_c('div', {
    staticClass: "header-table row"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n\t\t\t\t\t\t\tCabinets\n\t\t\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "attached-item row"
  }, [_c('div', {
    staticClass: "phantom-flex"
  }), _vm._v(" "), _c('div', {
    staticClass: "ctn-cta"
  }, [_c('div', {
    staticClass: "btn btn-red",
    on: {
      "click": _vm.showNewCabinet
    }
  }, [_c('span', {
    staticClass: "icon-form-plus"
  }), _vm._v(" Ajouter un cabinet\n\t\t\t\t\t\t\t\t")])])])]), _vm._v(" "), _c('Table', {
    attrs: {
      "elements": _vm.cabinets,
      "clickable": false
    },
    on: {
      "statuschange": _vm.updateStatus,
      "editCabinet": _vm.editCabinet
    }
  }), _vm._v(" "), _c('baseModal', {
    attrs: {
      "show": _vm.showAddCabinet,
      "content": _vm.contentModal,
      "data": {
        currentCabinet: _vm.currentCabinet
      },
      "disableClickOutside": true
    },
    on: {
      "close": function($event) {
        _vm.showAddCabinet = false
      }
    }
  })], 1)])])
},staticRenderFns: []}

/***/ }),
/* 633 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main column no-header",
    attrs: {
      "id": "app"
    }
  }, [_c('div', {
    staticClass: "background-login"
  }), _vm._v(" "), (_vm.hardLogin) ? _c('div', {
    staticClass: "login",
    class: {
      active: _vm.login
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(355),
      "alt": ""
    }
  }), _vm._v(" "), _c('form', {
    staticClass: "form-ui column",
    attrs: {
      "novalidate": ""
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.connect($event)
      }
    }
  }, [_c('div', {
    directives: [{
      name: "inputUI",
      rawName: "v-inputUI"
    }],
    staticClass: "ctn-input ctn-label",
    class: {
      error: _vm.errors.has('email')
    }
  }, [_c('label', {
    attrs: {
      "for": "email"
    }
  }, [_vm._v("Votre e-mail")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|email'),
      expression: "'required|email'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    attrs: {
      "data-vv-validate-on": "blur",
      "type": "email",
      "name": "email"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.errors.has('email')) ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.errors.first('email')))]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "inputUI",
      rawName: "v-inputUI"
    }],
    staticClass: "ctn-input ctn-label",
    class: {
      error: _vm.errors.has('password')
    }
  }, [_c('label', {
    attrs: {
      "for": "password"
    }
  }, [_vm._v("Mot de passe")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    attrs: {
      "type": "password",
      "name": "password"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.errors.has('password')) ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.errors.first('password')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "ctn-password-reset link",
    on: {
      "click": function($event) {
        _vm.$router.push({
          name: 'ResetPasswordEmailAsk'
        })
      }
    }
  }, [_vm._v("\n\t\t\t\tMot de passe oublié ?\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "ctn-connect"
  }, [_c('div', {
    staticClass: "btn btn-red",
    on: {
      "click": _vm.connect
    }
  }, [_vm._v("\n\t\t\t\t\tConnexion\n\t\t\t\t")])])]) : _vm._e(), _vm._v(" "), (!_vm.loginusMaximus) ? _c('div', {
    staticClass: "login forgot-password",
    class: {
      active: !_vm.hardLogin
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "bottom"
  }, [_c('div', {
    directives: [{
      name: "inputUI",
      rawName: "v-inputUI"
    }],
    staticClass: "ctn-input ctn-label",
    class: {
      error: _vm.errors.has('email oublié')
    }
  }, [_c('label', {
    attrs: {
      "for": "email"
    }
  }, [_vm._v("Votre e-mail")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|email'),
      expression: "'required|email'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.emailReset),
      expression: "emailReset"
    }],
    attrs: {
      "type": "email",
      "name": "email oublié"
    },
    domProps: {
      "value": (_vm.emailReset)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.emailReset = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.errors.has('email oublié')) ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.errors.first('email oublié')))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "ctn-connect"
  }, [_c('div', {
    staticClass: "btn btn-red",
    on: {
      "click": _vm.resetPassword
    }
  }, [_vm._v("\n\t\t\t\t\t\tEnvoyer\n\t\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "ctn-password-reset link",
    on: {
      "click": function($event) {
        _vm.$router.push({
          name: 'Login'
        })
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\tRetour à la connexion\n\t\t\t\t\t")])])])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "top"
  }, [_c('h2', [_vm._v("Mot de passe oublié")]), _vm._v(" "), _c('div', {
    staticClass: "label"
  }, [_vm._v("\n\t\t\t\t\tVeuillez entrer votre adresse-email pour obtenir un nouveau mot de passe\n\t\t\t\t")])])
}]}

/***/ }),
/* 634 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main column no-header",
    attrs: {
      "id": "app"
    }
  }, [_c('div', {
    staticClass: "background-login"
  }), _vm._v(" "), _c('div', {
    staticClass: "login forgot-password reset-password active"
  }, [(_vm.isValidToken) ? _c('div', {
    staticClass: "top"
  }, [_c('h2', [_vm._v("Réinitialiser le mot de passe")]), _vm._v(" "), _c('div', {
    staticClass: "label"
  }, [_vm._v("\n\t\t\t\tVeuillez saisir un nouveau mot de passe\n\t\t\t")])]) : _vm._e(), _vm._v(" "), (!_vm.isValidToken) ? _c('div', {
    staticClass: "bottom"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "ctn-connect"
  }, [_c('div', {
    staticClass: "btn btn-red",
    on: {
      "click": function($event) {
        _vm.$router.push({
          name: 'ResetPasswordEmailAsk'
        })
      }
    }
  }, [_vm._v("\n\t\t\t\t\tRéinitialisation mon mot de passe\n\t\t\t\t")])])]) : _c('div', {
    staticClass: "bottom"
  }, [_c('div', {
    staticClass: "form-elem-container"
  }, [_c('div', {
    directives: [{
      name: "inputUI",
      rawName: "v-inputUI"
    }],
    staticClass: "ctn-input ctn-label",
    class: {
      error: _vm.errors.has('nouveau mot de passe')
    }
  }, [_c('label', {
    attrs: {
      "for": "nouveau mot de passe"
    }
  }, [_vm._v("Nouveau mot de passe")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    attrs: {
      "type": "password",
      "name": "nouveau mot de passe"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "change": function($event) {
        _vm.errorsame = false
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.errors.has('nouveau mot de passe')) ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.errors.first('nouveau mot de passe')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-elem-container"
  }, [_c('div', {
    directives: [{
      name: "inputUI",
      rawName: "v-inputUI"
    }],
    staticClass: "ctn-input ctn-label",
    class: {
      error: _vm.errors.has('confirmation du mot de passe')
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.send($event)
      }
    }
  }, [_c('label', {
    attrs: {
      "for": "confirmation du mot de passe"
    }
  }, [_vm._v("Confirmation du mot de passe")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.passwordConfirm),
      expression: "passwordConfirm"
    }],
    attrs: {
      "type": "password",
      "name": "confirmation du mot de passe"
    },
    domProps: {
      "value": (_vm.passwordConfirm)
    },
    on: {
      "change": function($event) {
        _vm.errorsame = false
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.passwordConfirm = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.errors.has('confirmation du mot de passe')) ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.errors.first('confirmation du mot de passe')))]) : _vm._e(), _vm._v(" "), (_vm.errorsame) ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v("Les mots de passe doivent correspondre")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "ctn-connect"
  }, [_c('div', {
    staticClass: "btn btn-red",
    on: {
      "click": _vm.send
    }
  }, [_vm._v("\n\t\t\t\t\tValider\n\t\t\t\t")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "text-center"
  }, [_vm._v("\n\t\tPour des raisons de sécurité la réinitialisation de votre mot passe est valable 24h00."), _c('br'), _vm._v("\n\t\tMerci de bien vouloir demander à nouveau la réinitialisation de votre mot de passe.\n\t\t")])
}]}

/***/ }),
/* 635 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sub-main column subview-container client"
  }, [(_vm.user) ? _c('div', {
    staticClass: "sub-page column"
  }, [_c('section', {
    staticClass: "details-bar column activity-container container-background"
  }, [_c('div', {
    staticClass: "row container activity-container"
  }, [_c('div', {
    staticClass: "row avatar"
  }, [_c('div', {
    staticClass: "ctn-back",
    on: {
      "click": _vm.goBack
    }
  }, [_c('span', {
    staticClass: "icon-arrow-back"
  })]), _vm._v(" "), _c('div', {
    staticClass: "ctn-avatar"
  }, [_c('img', {
    attrs: {
      "src": _vm.client.picture,
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "bold details-bar-username"
  }, [_vm._v(_vm._s(_vm.user.first_name) + " " + _vm._s(_vm.user.last_name))]), _vm._v(" "), _c('div', [_vm._v("Client de "), _c('span', {
    staticClass: "bold"
  }, [_vm._v(_vm._s(((_vm.client.main_advisor.first_name) + " " + (_vm.client.main_advisor.last_name))))]), _vm._v(" chez "), _c('span', {
    staticClass: "bold"
  }, [_vm._v(_vm._s(_vm.user.office.name))])])])]), _vm._v(" "), _c('div', {
    staticClass: "row infos"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "label bold"
  }, [_vm._v("E-MAIL")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_vm._v(_vm._s(_vm.user.email))])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "label bold"
  }, [_vm._v("TELEPHONE")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_vm._v(_vm._s(_vm.user.phone))])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "label bold"
  }, [_vm._v("ADRESSE")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_vm._v(_vm._s(_vm.user.address))])])]), _vm._v(" "), _c('div', {
    staticClass: "ctn-cta"
  }, [_c('div', {
    staticClass: "btn btn-grey",
    on: {
      "click": function($event) {
        _vm.showClientModal = true
      }
    }
  }, [_vm._v("\n                      Editer\n                  ")]), _vm._v(" "), _c('div', {
    staticClass: "toggle"
  }, [_c('toggle-input', {
    attrs: {
      "value": _vm.user.enabled
    },
    on: {
      "change": _vm.updateClientStatus
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "contentrow row"
  }, [_c('div', {
    staticClass: "inner-row row"
  }, [_c('div', {
    staticClass: "half infos"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "boding column"
  }, [_c('div', {
    staticClass: "row info"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v(" Nom complet ")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v(" " + _vm._s(_vm.user.first_name) + " " + _vm._s(_vm.user.last_name))])]), _vm._v(" "), _c('div', {
    staticClass: "row info"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Date de naissance")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.user.birthdate))])]), _vm._v(" "), _c('div', {
    staticClass: "row info"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Téléphone")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.user.phone || '-'))])]), _vm._v(" "), _c('div', {
    staticClass: "row info"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Adresse mail")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.user.email || '-'))])]), _vm._v(" "), _c('div', {
    staticClass: "row info"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Adresse postal")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.user.address || '-'))])]), _vm._v(" "), _c('div', {
    staticClass: "row info"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Ville")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.user.city || '-'))])]), _vm._v(" "), _c('div', {
    staticClass: "row info"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Code postal")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.user.zipcode || '-'))])])])]), _vm._v(" "), _c('div', {
    staticClass: "half infos patrimoine column"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "boding column"
  }, [(!_vm.estate.success) ? _c('div', {
    staticClass: "no-patrimoine empty column"
  }, [_vm._v("\n                Votre client doit remplir "), _c('br'), _vm._v("\n                son Paysage Patrimonial pour "), _c('br'), _vm._v("\n                pouvoir commencer à investir.\n                ")]) : _c('div', {
    staticClass: "patrimoines take-place"
  }, [_c('div', {
    staticClass: "row info"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Age")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.estate.user.birthdate || '-'))])]), _vm._v(" "), _c('div', {
    staticClass: "row info"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Métier")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.estate.user.job || '-'))])]), _vm._v(" "), _c('div', {
    staticClass: "row info"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("CSP")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.estate.user.professional_category || '-'))])]), _vm._v(" "), _c('div', {
    staticClass: "row info"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Enfants")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.estate.user.kids.length) + " à charge")])]), _vm._v(" "), _c('div', {
    staticClass: "info row"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Revenu annuel")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.estate.private_estate_totals.total_incomes || '-'))])]), _vm._v(" "), _c('div', {
    staticClass: "info row"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Immobilier")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.estate.private_estate_totals.immobilier || '-'))])]), _vm._v(" "), _c('div', {
    staticClass: "info row"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Epargne")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.estate.private_estate_totals.total_savings || '-'))])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "half column appointment"
  })]), _vm._v(" "), _c('baseModal', {
    attrs: {
      "data": _vm.userModal,
      "show": _vm.showClientModal,
      "content": _vm.contentModal
    },
    on: {
      "close": function($event) {
        _vm.showClientModal = false
      }
    }
  })], 1) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "heading row"
  }, [_c('div', {
    staticClass: "title row"
  }, [_c('span', {
    staticClass: "icon-fiche-client-info"
  }), _vm._v("\n                Informations\n              ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "heading row"
  }, [_c('div', {
    staticClass: "title row"
  }, [_c('span', {
    staticClass: "icon-fiche-client-paysage"
  }), _vm._v("\n                Paysage Patrimonial\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "add row"
  })])
}]}

/***/ }),
/* 636 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "toggle-input",
    class: {
      active: _vm.custom
    },
    on: {
      "click": _vm.changeValue
    }
  }, [_c('div', {
    staticClass: "button"
  })])
},staticRenderFns: []}

/***/ }),
/* 637 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), _c('nav', {
    staticClass: "row"
  }, _vm._l((_vm.menu), function(item) {
    return (item.visibleForAdmin || _vm.isSuperAdmin) ? _c('router-link', {
      key: item.key,
      staticClass: "menu-item",
      attrs: {
        "to": {
          name: item.uri
        }
      },
      domProps: {
        "innerHTML": _vm._s(item.name)
      }
    }) : _vm._e()
  })), _vm._v(" "), _c('div', {
    staticClass: "manage row"
  }, [_c('router-link', {
    staticClass: "ctn-profil",
    attrs: {
      "to": {
        name: 'Profile'
      }
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.picture,
      "alt": ""
    }
  })])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "logo"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(355),
      "alt": ""
    }
  })])
}]}

/***/ }),
/* 638 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ag-table', {
    staticClass: "conseillers-table",
    attrs: {
      "columns": _vm.columnDefs,
      "rows": _vm.rowDataFiltered,
      "customOptions": _vm.tableOptions
    },
    on: {
      "cellclick": _vm.handleCellClick
    }
  })
},staticRenderFns: []}

/***/ }),
/* 639 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "subview-container column"
  }, [_c('div', {
    staticClass: "profile-container"
  }, [_c('div', {
    staticClass: "header-part row"
  }, [_c('div', {
    staticClass: "ctn-profile-light row"
  }, [_c('div', {
    staticClass: "ctn-label"
  }, [_c('div', {
    staticClass: "ctn-name"
  }, [_vm._v("\n            " + _vm._s(_vm.user.firstname) + " " + _vm._s(_vm.user.lastname) + "\n          ")])])]), _vm._v(" "), _c('div', {
    staticClass: "ctn-logout"
  }, [_c('div', {
    staticClass: "btn btn-red",
    on: {
      "click": _vm.logout
    }
  }, [_vm._v("\n          Déconnexion\n        ")])])]), _vm._v(" "), _c('div', {
    staticClass: "body-part row"
  }, [_c('div', {
    staticClass: "half edit-profile"
  }, [_c('form', {
    staticClass: "default-form-ui",
    attrs: {
      "novalidate": ""
    }
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n            Informations générales\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "form-elem-container"
  }, [_c('div', {
    staticClass: "ctn-input ctn-label",
    class: {
      error: _vm.errors.has('email')
    }
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|email'),
      expression: "'required|email'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.userM.email),
      expression: "userM.email"
    }],
    attrs: {
      "type": "email",
      "name": "email",
      "placeholder": "Email"
    },
    domProps: {
      "value": (_vm.userM.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.userM, "email", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.errors.has('email')) ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.errors.first('email')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-elem-container"
  }, [_c('div', {
    staticClass: "ctn-input ctn-label",
    class: {
      error: _vm.errors.has('prénom')
    }
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|alpha_dash_spaces'),
      expression: "'required|alpha_dash_spaces'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.userM.firstname),
      expression: "userM.firstname"
    }],
    attrs: {
      "type": "text",
      "name": "prénom",
      "placeholder": "Prénom"
    },
    domProps: {
      "value": (_vm.userM.firstname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.userM, "firstname", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.errors.has('prénom')) ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.errors.first('prénom')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-elem-container"
  }, [_c('div', {
    staticClass: "ctn-input ctn-label",
    class: {
      error: _vm.errors.has('nom')
    }
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|alpha_dash_spaces'),
      expression: "'required|alpha_dash_spaces'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.userM.lastname),
      expression: "userM.lastname"
    }],
    attrs: {
      "type": "text",
      "name": "nom",
      "placeholder": "Nom"
    },
    domProps: {
      "value": (_vm.userM.lastname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.userM, "lastname", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.errors.has('nom')) ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.errors.first('nom')))]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "half edit-password column"
  }, [_c('form', {
    staticClass: "form-ui default-form-ui",
    attrs: {
      "novalidate": ""
    }
  }, [_c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n              Mot de passe\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "link",
    on: {
      "click": function($event) {
        _vm.displayChangePassword = true
      }
    }
  }, [_vm._v("\n              Éditer le mot de passe\n            ")])])]), _vm._v(" "), _c('div', {
    staticClass: "btn btn-red save",
    on: {
      "click": _vm.saveProfile
    }
  }, [_vm._v("\n          Sauvegarder\n        ")])])])]), _vm._v(" "), _c('base-modal', {
    attrs: {
      "show": _vm.displayChangePassword,
      "content": _vm.contentModalPassword
    },
    on: {
      "close": function($event) {
        _vm.displayChangePassword = false
      }
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 640 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sub-main column"
  }, [_c('div', {
    staticClass: "sub-page column"
  }, [_c('section', {
    staticClass: "take-place column activity-container container-background"
  }, [_c('div', {
    staticClass: "header-table row"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n\t\t\t\t\t\t\tClients\n\t\t\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "attached-item row"
  }, [_c('div', {
    staticClass: "phantom-flex"
  }), _vm._v(" "), _c('div', {
    staticClass: "ctn-cta"
  }, [_c('div', {
    staticClass: "btn btn-red",
    on: {
      "click": function($event) {
        _vm.showAddClient = true
      }
    }
  }, [_c('span', {
    staticClass: "icon-form-plus"
  }), _vm._v(" Ajouter un client\n\t\t\t\t\t\t\t\t")])])])]), _vm._v(" "), _c('Table', {
    attrs: {
      "elements": _vm.clients,
      "clickable": true
    },
    on: {
      "statuschange": _vm.updateStatus
    }
  }), _vm._v(" "), _c('baseModal', {
    attrs: {
      "show": _vm.showAddClient,
      "content": _vm.contentModal
    },
    on: {
      "close": function($event) {
        _vm.showAddClient = false
      }
    }
  })], 1)])])
},staticRenderFns: []}

/***/ }),
/* 641 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.loader) ? _c('div', {
    staticClass: "loader-container"
  }, [_vm._m(0)]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "loader-image"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(608),
      "alt": ""
    }
  })])
}]}

/***/ }),
/* 642 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "take-place column activity-container"
  }, [_c('ag-grid-vue', {
    staticClass: "table-custom column",
    attrs: {
      "gridReady": _vm.onReady,
      "gridOptions": _vm.options,
      "columnDefs": _vm.columnsComputed,
      "rowData": _vm.rows,
      "enableSorting": true
    }
  }), _vm._v(" "), (_vm.showGrid && _vm.options.pagination) ? _c('div', {
    staticClass: "table-pagination"
  }, [_c('div', [_vm._v("Montrer "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.paginationPageSize),
      expression: "paginationPageSize"
    }],
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.paginationPageSize)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.paginationPageSize = $event.target.value
      }
    }
  }), _vm._v(" éléments par page")]), _vm._v(" "), _c('div', [_vm._v("Page "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentPage),
      expression: "currentPage"
    }],
    staticClass: "input-page",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.currentPage)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.currentPage = $event.target.value
      }
    }
  })])]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 643 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "custom-select",
    class: {
      solo: _vm.solo
    }
  }, [_c('div', {
    staticClass: "selected",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.display()
      }
    }
  }, [_vm._v("\n\t\t" + _vm._s(this.select || ' ') + "\n\t\t"), _c('span', {
    staticClass: "icon-arrow-full-down",
    class: {
      deploy: _vm.show
    }
  })]), _vm._v(" "), (_vm.show) ? _c('div', {
    staticClass: "items"
  }, _vm._l((_vm.items), function(item, key) {
    return _c('div', {
      key: key,
      staticClass: "item",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.setSelect(key)
        }
      }
    }, [(_vm.object) ? _c('span', [_vm._v(_vm._s(item.type))]) : _c('span', [_vm._v(_vm._s(item))])])
  })) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 644 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sub-main column"
  }, [(_vm.advisor) ? _c('div', {
    staticClass: "sub-page column"
  }, [_c('section', {
    staticClass: "details-bar column activity-container container-background"
  }, [_c('div', {
    staticClass: "row container activity-container"
  }, [_c('div', {
    staticClass: "row avatar"
  }, [_c('div', {
    staticClass: "ctn-back",
    on: {
      "click": _vm.goBack
    }
  }, [_c('span', {
    staticClass: "icon-arrow-back"
  })]), _vm._v(" "), _c('div', {
    staticClass: "ctn-avatar",
    style: ({
      backgroundImage: ("url(" + (_vm.advisor.picture) + ")")
    })
  }), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "bold details-bar-username"
  }, [_vm._v(_vm._s(_vm.advisor.first_name) + " " + _vm._s(_vm.advisor.last_name))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.advisor.roles[0] && _vm.advisor.roles[0] === "ROLE_ADVISOR" ? "Conseiller" : "Admin") + " chez "), _c('span', {
    staticClass: "bold"
  }, [_vm._v(_vm._s(_vm.advisor.office ? _vm.advisor.office : ''))])])])]), _vm._v(" "), _c('div', {
    staticClass: "row infos"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "label bold"
  }, [_vm._v("E-MAIL")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_vm._v(_vm._s(_vm.advisor.email))])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "label bold"
  }, [_vm._v("TELEPHONE")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_vm._v(_vm._s(_vm.advisor.phone))])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "label bold"
  }, [_vm._v("ADRESSE")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_vm._v(_vm._s(_vm.advisor.address))])])]), _vm._v(" "), _c('div', {
    staticClass: "ctn-cta"
  }, [_c('div', {
    staticClass: "btn btn-grey",
    on: {
      "click": function($event) {
        _vm.showAddConseiller = true
      }
    }
  }, [_vm._v("\n              Editer\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "toggle"
  }, [_c('toggle-input', {
    attrs: {
      "value": _vm.advisor.enabled
    },
    on: {
      "change": _vm.updateConseillerStatus
    }
  })], 1)])])]), _vm._v(" "), _c('section', {
    staticClass: "take-place column activity-container container-background"
  }, [_c('div', {
    staticClass: "header-table row"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n            Liste des clients de " + _vm._s(_vm.advisor.first_name) + " " + _vm._s(_vm.advisor.last_name) + "\n          ")])]), _vm._v(" "), _c('Table', {
    attrs: {
      "elements": _vm.displayedClients,
      "clickable": true
    },
    on: {
      "statuschange": _vm.updateClientStatus
    }
  }), _vm._v(" "), _c('baseModal', {
    attrs: {
      "data": _vm.advisor,
      "show": _vm.showAddConseiller,
      "content": _vm.contentModal
    },
    on: {
      "close": function($event) {
        _vm.showAddConseiller = false
      }
    }
  })], 1)]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 645 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ag-table', {
    attrs: {
      "columns": _vm.columnDefs,
      "rows": _vm.rowDataFiltered,
      "customOptions": _vm.tableOptions
    },
    on: {
      "cellclick": _vm.handleCellClick
    }
  })
},staticRenderFns: []}

/***/ }),
/* 646 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ag-table', {
    attrs: {
      "columns": _vm.columnDefs,
      "rows": _vm.rowDataFiltered,
      "customOptions": _vm.tableOptions
    },
    on: {
      "cellclick": _vm.handleCellClick
    }
  })
},staticRenderFns: []}

/***/ }),
/* 647 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sub-main column"
  }, [_c('div', {
    staticClass: "sub-page column"
  }, [_c('section', {
    staticClass: "take-place column activity-container container-background"
  }, [_c('div', {
    staticClass: "header-table row"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n\t\t\t\t\t\t\tConseillers\n\t\t\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "attached-item row"
  }, [_c('div', {
    staticClass: "phantom-flex"
  }), _vm._v(" "), _c('div', {
    staticClass: "ctn-cta"
  }, [_c('div', {
    staticClass: "btn btn-red",
    on: {
      "click": function($event) {
        _vm.showAddConseiller = true
      }
    }
  }, [_c('span', {
    staticClass: "icon-form-plus"
  }), _vm._v(" Ajouter un conseiller\n\t\t\t\t\t\t\t\t")])])])]), _vm._v(" "), _c('Table', {
    attrs: {
      "elements": _vm.conseillers,
      "clickable": true
    },
    on: {
      "statuschange": _vm.updateStatus
    }
  }), _vm._v(" "), _c('baseModal', {
    attrs: {
      "show": _vm.showAddConseiller,
      "content": _vm.contentModal
    },
    on: {
      "close": function($event) {
        _vm.showAddConseiller = false
      }
    }
  })], 1)])])
},staticRenderFns: []}

/***/ }),
/* 648 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "inner-modal"
  }, [_c('div', {
    staticClass: "head-modal spaced-row"
  }, [_c('div', [_c('div', {
    staticClass: "head-modal-title"
  }, [_vm._v("\n\t\t\t\t\t" + _vm._s((_vm.isEdit) ? 'Editer' : 'Ajouter') + " un client\n\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "head-modal-emphase"
  }, [_vm._v("\n\t\t\t\t\tModifiez les informations d’un client ou ajoutez en un.\n\t\t\t\t")])])]), _vm._v(" "), _c('div', {
    staticClass: "body-modal"
  }, [_c('form', {
    staticClass: "form-ui column default-form-ui"
  }, [_c('div', {
    staticClass: "ctn-duo-input row"
  }, [_c('div', {
    staticClass: "left inner-duo"
  }, [_c('div', {
    directives: [{
      name: "inputUI",
      rawName: "v-inputUI"
    }],
    staticClass: "ctn-input ctn-label",
    class: {
      error: _vm.errors.has('firstname')
    }
  }, [_c('label', {
    attrs: {
      "for": "firstname"
    }
  }, [_vm._v("Prénom")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|alpha_dash_spaces'),
      expression: "'required|alpha_dash_spaces'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.user.first_name),
      expression: "user.first_name"
    }],
    attrs: {
      "type": "text",
      "name": "firstname"
    },
    domProps: {
      "value": (_vm.user.first_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "first_name", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.errors.has('firstname')) ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.errors.first('firstname')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "right inner-duo"
  }, [_c('div', {
    directives: [{
      name: "inputUI",
      rawName: "v-inputUI"
    }],
    staticClass: "ctn-input ctn-label",
    class: {
      error: _vm.errors.has('name')
    }
  }, [_c('label', {
    attrs: {
      "for": "name"
    }
  }, [_vm._v("Nom")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|alpha_dash_spaces'),
      expression: "'required|alpha_dash_spaces'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.user.last_name),
      expression: "user.last_name"
    }],
    attrs: {
      "type": "text",
      "name": "name"
    },
    domProps: {
      "value": (_vm.user.last_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "last_name", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.errors.has('name')) ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.errors.first('name')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "ctn-duo-input row"
  }, [_c('div', {
    staticClass: "left inner-duo"
  }, [_c('div', {
    directives: [{
      name: "inputUI",
      rawName: "v-inputUI"
    }],
    staticClass: "ctn-input ctn-label",
    class: {
      error: _vm.errors.has('company')
    }
  }, [_c('label', {
    attrs: {
      "for": "company"
    }
  }, [_vm._v("Nom Entreprise")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.company_name),
      expression: "user.company_name"
    }],
    attrs: {
      "type": "text",
      "name": "company"
    },
    domProps: {
      "value": (_vm.user.company_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "company_name", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.errors.has('company')) ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.errors.first('company')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "right inner-duo"
  }, [_c('div', {
    directives: [{
      name: "inputUI",
      rawName: "v-inputUI"
    }],
    staticClass: "ctn-input ctn-label",
    class: {
      error: _vm.errors.has('siret')
    }
  }, [_c('label', {
    attrs: {
      "for": "siret"
    }
  }, [_vm._v("Siret Entreprise")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.company_siret),
      expression: "user.company_siret"
    }],
    attrs: {
      "type": "text",
      "name": "siret"
    },
    domProps: {
      "value": (_vm.user.company_siret)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "company_siret", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.errors.has('siret')) ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.errors.first('siret')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "ctn-duo-input row"
  }, [_c('div', {
    staticClass: "left inner-duo"
  }, [_c('div', {
    directives: [{
      name: "inputUI",
      rawName: "v-inputUI"
    }],
    staticClass: "ctn-input ctn-label",
    class: {
      error: _vm.errors.has('address')
    }
  }, [_c('label', {
    attrs: {
      "for": "address"
    }
  }, [_vm._v("Adresse du client")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.user.address),
      expression: "user.address"
    }],
    attrs: {
      "type": "text",
      "name": "address"
    },
    domProps: {
      "value": (_vm.user.address)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "address", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.errors.has('address')) ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.errors.first('address')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "right inner-duo"
  }, [_c('div', {
    directives: [{
      name: "inputUI",
      rawName: "v-inputUI"
    }],
    staticClass: "ctn-input ctn-label",
    class: {
      error: _vm.errors.has('zipcode')
    }
  }, [_c('label', {
    attrs: {
      "for": "postalcode"
    }
  }, [_vm._v("Code postal")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|length:5'),
      expression: "'required|length:5'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.user.zipcode),
      expression: "user.zipcode"
    }],
    attrs: {
      "type": "text",
      "name": "zipcode"
    },
    domProps: {
      "value": (_vm.user.zipcode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "zipcode", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.errors.has('zipcode')) ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.errors.first('zipcode')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "ctn-duo-input row"
  }, [_c('div', {
    staticClass: "left inner-duo"
  }, [_c('div', {
    directives: [{
      name: "inputUI",
      rawName: "v-inputUI"
    }],
    staticClass: "ctn-input ctn-label",
    class: {
      error: _vm.errors.has('city')
    }
  }, [_c('label', {
    attrs: {
      "for": "city"
    }
  }, [_vm._v("Ville")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|alpha_spaces'),
      expression: "'required|alpha_spaces'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.user.city),
      expression: "user.city"
    }],
    attrs: {
      "type": "text",
      "name": "city"
    },
    domProps: {
      "value": (_vm.user.city)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "city", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.errors.has('city')) ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.errors.first('city')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "right inner-duo"
  }, [_c('div', {
    directives: [{
      name: "selectUI",
      rawName: "v-selectUI"
    }],
    staticClass: "ctn-input form-elem-container ctn-select ctn-label",
    class: {
      error: _vm.errors.has('country')
    }
  }, [_c('label', {
    attrs: {
      "for": "select"
    }
  }, [_vm._v("Pays")]), _vm._v(" "), _c('custom-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "items": _vm.countries,
      "data-vv-name": "country",
      "has-error": _vm.errors.has('country')
    },
    model: {
      value: (_vm.user.country),
      callback: function($$v) {
        _vm.$set(_vm.user, "country", $$v)
      },
      expression: "user.country"
    }
  })], 1), _vm._v(" "), (_vm.errors.has('country')) ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.errors.first('country')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "ctn-duo-input row"
  }, [_c('div', {
    staticClass: "left inner-duo"
  }, [_c('div', {
    directives: [{
      name: "inputUI",
      rawName: "v-inputUI"
    }],
    staticClass: "ctn-input ctn-label",
    class: {
      error: _vm.errors.has('phone')
    }
  }, [_c('label', {
    attrs: {
      "for": "phone"
    }
  }, [_vm._v("Téléphone")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|numeric|length:10'),
      expression: "'required|numeric|length:10'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.user.phone),
      expression: "user.phone"
    }],
    attrs: {
      "type": "phone",
      "name": "phone"
    },
    domProps: {
      "value": (_vm.user.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "phone", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.errors.has('phone')) ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.errors.first('phone')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "right inner-duo"
  }, [_c('div', {
    directives: [{
      name: "inputUI",
      rawName: "v-inputUI"
    }],
    staticClass: "ctn-input ctn-label",
    class: {
      error: _vm.errors.has('date de naissance')
    }
  }, [_c('label', {
    staticClass: "active",
    attrs: {
      "for": "date de naissance"
    }
  }, [_vm._v("Date de naissance")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.user.birthdate),
      expression: "user.birthdate"
    }],
    attrs: {
      "type": "date",
      "name": "date de naissance"
    },
    domProps: {
      "value": (_vm.user.birthdate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "birthdate", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "inputUI",
      rawName: "v-inputUI"
    }],
    staticClass: "ctn-input ctn-label",
    class: {
      error: _vm.errors.has('email')
    }
  }, [_c('label', {
    attrs: {
      "for": "email"
    }
  }, [_vm._v("Adresse mail")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|email'),
      expression: "'required|email'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.user.email),
      expression: "user.email"
    }],
    attrs: {
      "type": "email",
      "name": "mail"
    },
    domProps: {
      "value": (_vm.user.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "email", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.errors.has('email')) ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.errors.first('email')))]) : _vm._e(), _vm._v(" "), (_vm.errors.has('password')) ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.errors.first('password')))]) : _vm._e(), _vm._v(" "), (_vm.isSuperAdmin) ? _c('div', {
    staticClass: "ctn-duo-input row"
  }, [_c('div', {
    staticClass: "left inner-duo"
  }, [_c('div', {
    directives: [{
      name: "selectUI",
      rawName: "v-selectUI"
    }],
    staticClass: "ctn-input form-elem-container ctn-select ctn-label",
    class: {
      error: _vm.errors.has('office')
    }
  }, [_c('label', {
    attrs: {
      "for": "select"
    }
  }, [_vm._v("Cabinet du client")]), _vm._v(" "), _c('custom-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "items": _vm.cabinetsNames,
      "data-vv-value-path": "mutableValue",
      "data-vv-name": "office",
      "has-error": _vm.errors.has('office')
    },
    model: {
      value: (_vm.user.office),
      callback: function($$v) {
        _vm.$set(_vm.user, "office", $$v)
      },
      expression: "user.office"
    }
  })], 1), _vm._v(" "), (_vm.errors.has('office')) ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.errors.first('office')))]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "ctn-cta right row"
  }, [_c('div', {
    staticClass: "btn btn-gold",
    on: {
      "click": _vm.close
    }
  }, [_vm._v("Annuler")]), _vm._v(" "), _c('div', {
    staticClass: "btn btn-red",
    on: {
      "click": _vm.validateBeforeSubmit
    }
  }, [_vm._v("Enregistrer")])])])])])
},staticRenderFns: []}

/***/ }),
/* 649 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.realLaunch),
      expression: "realLaunch"
    }],
    staticClass: "modal-container row",
    class: {
      activated: _vm.launch
    },
    on: {
      "click": _vm.closeFromOutside
    }
  }, [_c('div', {
    staticClass: "modal-content",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [(_vm.show) ? _c(_vm.content, {
    tag: "component",
    attrs: {
      "data": _vm.data
    },
    on: {
      "close": _vm.close
    }
  }) : _vm._e()], 1)])
},staticRenderFns: []}

/***/ }),
/* 650 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main column",
    attrs: {
      "id": "app"
    }
  }, [_c('my-header', {
    on: {
      "notif-open": function($event) {
        _vm.notifPanelActive = true
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "page column"
  }, [_c('router-view')], 1), _vm._v(" "), _c('notification-panel', {
    attrs: {
      "active": _vm.notifPanelActive
    },
    on: {
      "notif-close": function($event) {
        _vm.notifPanelActive = false
      }
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 651 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "phantom-container"
  }, [_c('notifications', {
    attrs: {
      "group": "default"
    }
  }), _vm._v(" "), _c('router-view'), _vm._v(" "), _c('loader')], 1)
},staticRenderFns: []}

/***/ }),
/* 652 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ag-table', {
    attrs: {
      "columns": _vm.columnDefs,
      "rows": _vm.rowDataFiltered,
      "customOptions": _vm.tableOptions
    },
    on: {
      "cellclick": _vm.handleCellClick
    }
  })
},staticRenderFns: []}

/***/ }),
/* 653 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "notifications-panel-container",
    class: {
      active: _vm.active
    },
    on: {
      "click": _vm.setActive
    }
  }, [_c('section', {
    staticClass: "notification-panel",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "head row"
  }, [_c('span', {
    staticClass: "icon-volet-notif"
  }), _vm._v(" "), _c('div', {
    staticClass: "label"
  }, [_vm._v("\n\t\t\t\tNotifications\n\t\t\t")]), _vm._v(" "), _c('span', {
    staticClass: "close icon-form-close",
    on: {
      "click": _vm.setActive
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "day"
  }, [_vm._v("\n\t\t\t" + _vm._s(_vm._f("moment")(new Date(), 'dddd DD MMMM')) + "\n\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "ctn-notifications"
  }, _vm._l((_vm.notifications), function(notification) {
    return _c('div', {
      staticClass: "notification"
    }, [(notification.type === 'article') ? _c('div', {
      staticClass: "head-notif row"
    }, [_c('span', {
      staticClass: "icon-notif-article"
    }), _vm._v(" "), _c('div', {
      staticClass: "label"
    }, [_vm._v("Nouvel Article")]), _vm._v(" "), _c('div', {
      staticClass: "hour"
    }, [_vm._v(_vm._s(_vm._f("moment")(notification.date, 'HH[h]mm')))])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "body-notif"
    }, [_vm._v("\n\t\t\t\t\t" + _vm._s(notification.text) + "\n\t\t\t\t")])])
  }))])])
},staticRenderFns: []}

/***/ }),
/* 654 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ctn-duo-input row domain-selector-container"
  }, [_c('div', {
    staticClass: "left inner-duo"
  }, [_c('div', {
    directives: [{
      name: "inputUI",
      rawName: "v-inputUI"
    }],
    staticClass: "ctn-input form-elem-container ctn-select ctn-label custom-selector",
    class: {
      error: _vm.errors.has('domain_type')
    }
  }, [(!_vm.domainType) ? _c('label', {
    attrs: {
      "for": "select"
    }
  }, [_vm._v("Type de domaine")]) : _vm._e(), _vm._v(" "), _c('v-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "options": _vm.domainTypes,
      "data-vv-value-path": "mutableValue",
      "data-vv-name": "domain_type",
      "has-error": _vm.errors.has('domain_type')
    },
    model: {
      value: (_vm.domainType),
      callback: function($$v) {
        _vm.domainType = $$v
      },
      expression: "domainType"
    }
  })], 1), _vm._v(" "), (_vm.errors.has('domain_type')) ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.errors.first('domain_type')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "right inner-duo"
  }, [_c('div', {
    directives: [{
      name: "inputUI",
      rawName: "v-inputUI"
    }],
    staticClass: "ctn-input ctn-label",
    class: {
      error: _vm.errors.has('domain')
    }
  }, [_c('label', {
    attrs: {
      "for": "domain"
    }
  }, [_vm._v("Nom de domaine")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.domain),
      expression: "domain"
    }],
    attrs: {
      "type": "text",
      "name": "domain"
    },
    domProps: {
      "value": (_vm.domain)
    },
    on: {
      "change": _vm.domainUpdated,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.domain = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.errors.has('domain')) ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.errors.first('domain')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "domain-selector-trash"
  }, [_c('span', {
    staticClass: "icon-file-trash",
    on: {
      "click": function($event) {
        _vm.$emit('deleteDomain', _vm.index)
      }
    }
  })])])
},staticRenderFns: []}

/***/ }),
/* 655 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "inner-modal"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "body-modal"
  }, [_c('form', {
    staticClass: "form-ui default-form-ui"
  }, [_c('div', {
    staticClass: "form-elem-container"
  }, [_c('div', {
    directives: [{
      name: "inputUI",
      rawName: "v-inputUI"
    }],
    staticClass: "ctn-input ctn-label",
    class: {
      error: _vm.errors.has('mot de passe actuel')
    }
  }, [_c('label', {
    attrs: {
      "for": "password"
    }
  }, [_vm._v("mot de passe actuel")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    attrs: {
      "type": "password",
      "name": "mot de passe actuel"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.errors.has('mot de passe actuel')) ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.errors.first('mot de passe actuel')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-elem-container"
  }, [_c('div', {
    directives: [{
      name: "inputUI",
      rawName: "v-inputUI"
    }],
    staticClass: "ctn-input ctn-label",
    class: {
      error: _vm.errors.has('nouveau mot de passe')
    }
  }, [_c('label', {
    attrs: {
      "for": "newPassword1"
    }
  }, [_vm._v("nouveau mot de passe")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.newPassword1),
      expression: "newPassword1"
    }],
    attrs: {
      "type": "password",
      "name": "nouveau mot de passe"
    },
    domProps: {
      "value": (_vm.newPassword1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newPassword1 = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.errors.has('nouveau mot de passe')) ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.errors.first('nouveau mot de passe')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-elem-container"
  }, [_c('div', {
    directives: [{
      name: "inputUI",
      rawName: "v-inputUI"
    }],
    staticClass: "ctn-input ctn-label",
    class: {
      error: _vm.errors.has('confirmation du nouveau mot de passe')
    }
  }, [_c('label', {
    attrs: {
      "for": "newPassword2"
    }
  }, [_vm._v("confirmation du nouveau mot de passe")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.newPassword2),
      expression: "newPassword2"
    }],
    attrs: {
      "type": "password",
      "name": "confirmation du nouveau mot de passe"
    },
    domProps: {
      "value": (_vm.newPassword2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newPassword2 = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.errors.has('confirmation du nouveau mot de passe')) ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.errors.first('confirmation du nouveau mot de passe')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "ctn-cta right row"
  }, [_c('div', {
    staticClass: "btn btn-gold",
    on: {
      "click": _vm.close
    }
  }, [_vm._v("Annuler")]), _vm._v(" "), _c('div', {
    staticClass: "btn btn-red",
    on: {
      "click": _vm.confirm
    }
  }, [_vm._v("Enregistrer")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "head-modal"
  }, [_c('div', {
    staticClass: "head-modal-title"
  }, [_vm._v("\n\t\t\tEditer le mot de passe\n\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "head-modal-emphase"
  }, [_vm._v("\n\t\t\tModifier votre mot de passe pour plus de sécurité\n\t\t")])])
}]}

/***/ })
]),[464]);


// WEBPACK FOOTER //
// static/js/app.bc761e514c94c76bd07f.js